<template>
  <div class="app-container">
    <el-card shadow="never" style="margin-bottom: 16px; background: #f9fbff;">
      <div style="display:flex; align-items:center; justify-content: space-between;">
        <div style="display:flex; align-items:center; gap:10px;">
          <i class="el-icon-edit-outline" style="color:#409eff; font-size:20px;"></i>
          <div>
            <div style="font-weight:700; font-size:16px; color:#303133;">题库管理</div>
            <div style="color:#606266; font-size:13px;">
              当前题库：{{ repoTitle || '未选择' }}
            </div>
          </div>
        </div>
        <div>
          <el-button type="text" @click="goBack" style="color:#409eff;">返回题库题目管理</el-button>
        </div>
      </div>
    </el-card>

    <!-- 工具栏：查询与手动添加 -->
    <el-form :inline="true" :model="query" class="demo-form-inline" style="margin-bottom: 10px;">
      <el-form-item label="题库">
        <repo-select v-model="query.repoId" :multi="false" @change="handleRepoChange" :disabled="!!$route.query.repoId" />
      </el-form-item>
      <el-form-item label="题干">
        <el-input v-model="query.content" placeholder="输入题干关键词" />
      </el-form-item>
      <el-form-item label="年份">
        <el-select v-model="query.year" placeholder="全部年份" clearable filterable style="width: 120px;">
          <el-option :label="'全部'" :value="''"></el-option>
          <el-option v-for="y in yearOptions" :key="y" :label="y" :value="y"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="warning" icon="el-icon-document" :disabled="!query.year" @click="previewPaper">预览试卷</el-button>
        <el-button @click="resetSearch">重置</el-button>
        <el-button type="success" @click="showManualForm = true">手动添加题目</el-button>
        <el-button type="primary" @click="ocrImportDialogVisible = true">OCR导入</el-button>
        <el-button type="primary" @click="pdfImportDialogVisible = true">PDF导入</el-button>
        <el-button type="primary" @click="wordImportDialogVisible = true">markdown导入</el-button>
        <el-button v-show="!showManualForm" type="danger" :disabled="!hasSelection" @click="handleBatchDelete">批量删除</el-button>
      </el-form-item>
    </el-form>

    <!-- OCR导入对话框 -->
    <el-dialog width="600px" :show-close="false" :close-on-click-modal="false" title="OCR导入" :visible.sync="ocrImportDialogVisible">
      请选择科目：
      <repo-select v-model="query.repoId" style="margin-bottom: 10px; width: 100%" @change="handleRepoChange" :disabled="!!$route.query.repoId" />
      <div v-if="$route.query.repoId" style="margin-bottom: 10px; color: #409eff; font-size: 14px;">
        <i class="el-icon-info"></i> 当前已自动选择题库：{{ repoTitle }}
      </div>
      <el-upload class="upload-demo" drag action="" multiple :limit="10" accept=".jpg,.jpeg,.png"
        :auto-upload="false" :on-remove="handleOcrFileRemove" :on-change="handleOcrFileChange" :file-list="ocrFileList">
        <i class="el-icon-upload" />
        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">支持上传jpg/png文件，最多10张</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ocrImportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitOcrFiles">提交</el-button>
      </div>
    </el-dialog>

    <!-- PDF导入对话框 -->
    <el-dialog title="PDF导入" :visible.sync="pdfImportDialogVisible" width="400px">
      请选择科目：
      <repo-select v-model="query.repoId" style="margin-bottom: 10px; width: 100%" @change="handleRepoChange" :disabled="!!$route.query.repoId" />
      <div v-if="$route.query.repoId" style="margin-bottom: 10px; color: #409eff; font-size: 14px;">
        <i class="el-icon-info"></i> 当前已自动选择题库：{{ repoTitle }}
      </div>
      <el-upload class="upload-demo" drag action="" :auto-upload="false" :file-list="pdfFileList" :on-change="handlePdfFileChange" :on-remove="handlePdfFileRemove" accept=".pdf" :limit="1">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将PDF文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传PDF文件</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pdfImportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPdfFile">提交</el-button>
      </span>
    </el-dialog>

    <!-- markdown导入对话框 -->
    <el-dialog title="markdown导入" :visible.sync="wordImportDialogVisible" width="400px">
      请选择科目：
      <repo-select v-model="query.repoId" style="margin-bottom: 10px; width: 100%" @change="handleRepoChange" :disabled="!!$route.query.repoId" />
      <div v-if="$route.query.repoId" style="margin-bottom: 10px; color: #409eff; font-size: 14px;">
        <i class="el-icon-info"></i> 当前已自动选择题库：{{ repoTitle }}
      </div>
      <el-upload class="upload-demo" drag action="" :auto-upload="false" :file-list="wordFileList" :on-change="handleWordFileChange" :on-remove="handleWordFileRemove" accept=".doc,.docx,.md,.markdown" :limit="1">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将Markdown文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">支持  .md / .markdown</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wordImportDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitWordFile">提交</el-button>
      </span>
    </el-dialog>

    <!-- 导入结果：可编辑，风格对齐通用试题页 -->
    <el-dialog title="导入结果" :visible.sync="importResultVisible" width="80%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <!-- 统计信息 -->
      <div style="margin-bottom: 20px; padding: 15px; background-color: #f5f7fa; border-radius: 4px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #409eff;">{{ normalizedResults.length }}</div>
              <div style="color: #666;">总题目数</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #67c23a;">{{ getChoiceCount() }}</div>
              <div style="color: #666;">选择题</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #e6a23c;">{{ getEssayCount() }}</div>
              <div style="color: #666;">简答题</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div style="text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #606266;">{{ importType==='pdf' ? (pdfResults.length || 0) : (ocrResults.length || 0) }}</div>
              <div style="color: #666;">原始记录数</div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 可编辑列表展示（根据来源切换表格） -->
      <div style="margin-bottom: 8px; display:flex; gap:8px;">
        <el-button size="mini" icon="el-icon-plus" @click="addQuestion">新增一题</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="resetEditedResults">重置为原始识别</el-button>
      </div>
      <!-- Word/AMC 结果表（带中英题干、解析与答案可编辑） -->
      <el-table v-if="importType==='word'" :data="editResults" border style="width: 100%" max-height="500" row-key="question_id">
        <el-table-column prop="question_id" label="题号" width="90" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="索引" width="110" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.index" placeholder="索引（question_id）" />
          </template>
        </el-table-column>
        <el-table-column label="年份" width="160" align="center">
          <template slot="header">
            <div style="display:flex; flex-direction:column; align-items:center; gap:6px;">
              <div>年份</div>
              <el-select v-model="bulkYear" placeholder="批量设置" size="mini" style="width:120px;" @change="applyBulkYear">
                <el-option v-for="y in fullYearOptions" :key="y" :label="y" :value="y"></el-option>
              </el-select>
            </div>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.year" filterable placeholder="选择年份" style="width:120px;">
              <el-option v-for="y in fullYearOptions" :key="y" :label="y" :value="y"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="题干(中文)" min-width="260">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="3" v-model="scope.row.contentCn" />
            <div v-if="scope.row.contentCn" class="latex-preview" style="margin-top:6px; padding:8px; background:#f9f9f9; border-radius:4px; border:1px solid #eee;">
              <div style="font-size:11px; color:#909399; margin-bottom:4px;">预览:</div>
              <div v-html="renderMathFormula(scope.row.contentCn)"></div>
            </div>
            <div v-if="scope.row.image" style="margin-top:6px;">
              <el-image
                :src="resolveImageUrl(scope.row.image)"
                fit="contain"
                style="max-width: 320px; max-height: 240px; border: 1px solid #f0f0f0;"
                :preview-src-list="[resolveImageUrl(scope.row.image)]"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="题干(English)" min-width="260">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="3" v-model="scope.row.contentEn" />
            <div v-if="scope.row.contentEn" class="latex-preview" style="margin-top:6px; padding:8px; background:#f9f9f9; border-radius:4px; border:1px solid #eee;">
              <div style="font-size:11px; color:#909399; margin-bottom:4px;">Preview:</div>
              <div v-html="renderMathFormula(scope.row.contentEn)"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="标签" min-width="220">
          <template slot-scope="scope">
            <el-input v-model="scope.row.tags" placeholder="如：代数-基础运算;数论-质数" />
          </template>
        </el-table-column>
        <el-table-column label="图片" width="180" align="center">
          <template slot-scope="scope">
            <file-upload-local v-model="scope.row.image" accept="image/*" list-type="picture" :limit="1" action-url="api/file/uploadTo/amc-question-test" bucket="amc-question-test" />
          </template>
        </el-table-column>
        <el-table-column label="选项" min-width="340">
          <template slot-scope="scope">
            <div>
              <div v-for="(opt, idx) in (scope.row.options || [])" :key="idx" style="margin-bottom:12px; padding:8px; background:#fafafa; border-radius:4px;">
                <div style="display:flex; align-items:center; gap:6px;">
                  <span style="color:#909399; width:18px; font-weight:bold;">{{ String.fromCharCode(65 + idx) }}.</span>
                  <el-input v-model="scope.row.options[idx].text" placeholder="选项内容" style="flex:1;" />
                  <el-button type="text" icon="el-icon-delete" style="color:#f56c6c;" @click="removeOption(scope.$index, idx)" />
                </div>
                <div v-if="scope.row.options[idx].text" style="margin-left:24px; margin-top:4px; padding:4px 8px; background:#fff; border-radius:4px; font-size:12px; border:1px solid #eee;">
                  <span v-html="renderMathFormula(scope.row.options[idx].text)"></span>
                </div>
                <div style="margin-left:24px; margin-top:6px;">
                  <div style="display:flex; align-items:center; gap:8px;">
                    <span style="font-size:12px; color:#909399;">选项图片:</span>
                    <file-upload-local
                      :key="`word-opt-upload-${scope.$index}-${idx}-${scope.row.options[idx].image || 'empty'}`"
                      v-model="scope.row.options[idx].image"
                      accept="image/*"
                      list-type="picture"
                      :limit="1"
                      action-url="api/file/uploadTo/amc-question-test"
                      bucket="amc-question-test"
                      style="display:inline-block;"
                    />
                  </div>
                  <div v-if="scope.row.options[idx].image" style="margin-top:4px; display:flex; align-items:center; gap:8px;">
                    <el-image
                      :src="resolveImageUrl(scope.row.options[idx].image)"
                      fit="contain"
                      style="max-width:120px; max-height:80px; border:1px solid #eee; border-radius:4px;"
                      :preview-src-list="[resolveImageUrl(scope.row.options[idx].image)]"
                    />
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="clearImportOptionImage(scope.$index, idx)"
                    >删除</el-button>
                  </div>
                </div>
              </div>
              <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addOption(scope.$index)">添加选项</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="正确答案" width="140" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.correctAnswer" placeholder="如：A 或 A;C" />
          </template>
        </el-table-column>
        <el-table-column label="难度" width="160" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.difficulty" placeholder="如: 01(简单)" size="mini" style="width: 140px;" />
          </template>
        </el-table-column>
        <el-table-column label="解析(中文)" min-width="260">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="3" v-model="scope.row.analysisCn" />
            <div v-if="scope.row.analysisCn" class="latex-preview" style="margin-top:6px; padding:8px; background:#f9f9f9; border-radius:4px; border:1px solid #eee;">
              <div style="font-size:11px; color:#909399; margin-bottom:4px;">预览:</div>
              <div v-html="renderMathFormula(scope.row.analysisCn)"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="解析(English)" min-width="260">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="3" v-model="scope.row.analysisEn" />
            <div v-if="scope.row.analysisEn" class="latex-preview" style="margin-top:6px; padding:8px; background:#f9f9f9; border-radius:4px; border:1px solid #eee;">
              <div style="font-size:11px; color:#909399; margin-bottom:4px;">Preview:</div>
              <div v-html="renderMathFormula(scope.row.analysisEn)"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-popconfirm title="确认删除该题吗？" @onConfirm="removeQuestion(scope.$index)">
              <el-button slot="reference" type="danger" icon="el-icon-delete" circle />
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- OCR/PDF 结果表（原有样式） -->
      <el-table v-else :data="editResults" border style="width: 100%" max-height="500" row-key="question_id">
        <el-table-column prop="question_id" label="题号" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.question_id || scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="题干(中/英)" min-width="300">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.contentCn" style="color:#303133;">
                <span style="color:#909399;">[CN]</span>
                <span v-html="renderMathFormula(scope.row.contentCn)"></span>
              </div>
              <div v-if="scope.row.contentEn" style="color:#606266; margin-top:4px;">
                <span style="color:#909399;">[EN]</span>
                <span v-html="renderMathFormula(scope.row.contentEn)"></span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stem" label="题目内容" min-width="360">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="3" v-model="scope.row.stem" />
          </template>
        </el-table-column>
        <el-table-column label="选项" min-width="380">
          <template slot-scope="scope">
            <div>
              <div v-for="(opt, idx) in (scope.row.options || [])" :key="idx" style="margin-bottom:12px; padding:8px; background:#fafafa; border-radius:4px;">
                <div style="display:flex; align-items:center; gap:6px;">
                  <span style="color:#909399; width:18px; font-weight:bold;">{{ String.fromCharCode(65 + idx) }}.</span>
                  <el-input v-model="scope.row.options[idx].text" placeholder="选项内容" style="flex:1;" />
                  <el-button type="text" icon="el-icon-delete" style="color:#f56c6c;" @click="removeOption(scope.$index, idx)" />
                </div>
                <div style="margin-left:24px; margin-top:6px;">
                  <div style="display:flex; align-items:center; gap:8px;">
                    <span style="font-size:12px; color:#909399;">选项图片:</span>
                    <file-upload-local
                      :key="`import-opt-upload-${scope.$index}-${idx}-${scope.row.options[idx].image || 'empty'}`"
                      v-model="scope.row.options[idx].image"
                      accept="image/*"
                      list-type="picture"
                      :limit="1"
                      action-url="api/file/uploadTo/amc-question-test"
                      bucket="amc-question-test"
                      style="display:inline-block;"
                    />
                  </div>
                  <div v-if="scope.row.options[idx].image" style="margin-top:4px; display:flex; align-items:center; gap:8px;">
                    <el-image
                      :src="resolveImageUrl(scope.row.options[idx].image)"
                      fit="contain"
                      style="max-width:120px; max-height:80px; border:1px solid #eee; border-radius:4px;"
                      :preview-src-list="[resolveImageUrl(scope.row.options[idx].image)]"
                    />
                    <el-button
                      size="mini"
                      type="danger"
                      plain
                      @click="clearImportOptionImage(scope.$index, idx)"
                    >删除</el-button>
                  </div>
                </div>
              </div>
              <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addOption(scope.$index)">添加选项</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-popconfirm title="确认删除该题吗？" @onConfirm="removeQuestion(scope.$index)">
              <el-button slot="reference" type="danger" icon="el-icon-delete" circle />
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importResultVisible = false">关 闭</el-button>
        <el-button type="primary" @click="saveImportResults">保存到题库</el-button>
      </div>
    </el-dialog>

    <!-- 已有题目列表 -->
    <el-card v-show="!showManualForm" shadow="always">
      <el-table ref="questionTable" :data="pagedRecords" border fit highlight-current-row :header-cell-style="{background:'#f2f3f4',color:'#555','font-weight':'bold','line-height':'32px'}" v-loading="loading" max-height="520" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column label="ID" align="center" width="120">
          <template slot-scope="scope">{{ scope.row.number || scope.row.id }}</template>
        </el-table-column>
        <el-table-column label="图片" width="100" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="getFirstImage(scope.row)"
              :src="resolveImageUrl(getFirstImage(scope.row))"
              :preview-src-list="getImageList(scope.row).map(img => resolveImageUrl(img))"
              style="width:60px;height:60px;object-fit:contain;"
            />
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="题干(中文)" min-width="260">
          <template slot-scope="scope">
            <div v-html="renderContentWithoutImage(scope.row.contentCn)"></div>
          </template>
        </el-table-column>
        <el-table-column label="题干(English)" min-width="260">
          <template slot-scope="scope">
            <div v-html="renderContentWithoutImage(scope.row.contentEn)"></div>
          </template>
        </el-table-column>
        <el-table-column label="答案" min-width="120">
          <template slot-scope="scope">
            <div v-html="renderMathFormula(scope.row.answer)"></div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="解析" min-width="180">
          <template slot-scope="scope">
            <div v-html="renderMathFormula(scope.row.analysisCn || scope.row.analysisEn || scope.row.analysis)"></div>
          </template>
        </el-table-column> -->
        <el-table-column label="解析(中文)" min-width="260">
          <template slot-scope="scope">
            <div v-html="renderMathFormula(scope.row.analysisCn)"></div>
          </template>
        </el-table-column>
        <el-table-column label="解析(English)" min-width="260">
          <template slot-scope="scope">
            <div v-html="renderMathFormula(scope.row.analysisEn)"></div>
          </template>
        </el-table-column>
        <el-table-column label="知识点" min-width="160">
          <template slot-scope="scope">
            <span>{{ getKnowledgeDisplay(scope.row.knowledge) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="options" label="选项" min-width="300">
          <template slot-scope="scope">
            <div class="options-container">
              <div
                v-for="(op, idx) in parseOptions(scope.row)"
                :key="idx"
                class="option-item"
                style="margin-bottom: 4px;"
              >
                <span v-html="renderOptionTextOnly(op)"></span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="选项图片" width="180" align="center">
          <template slot-scope="scope">
            <div style="display: flex; flex-wrap: wrap; gap: 4px; justify-content: center;">
              <div
                v-for="(op, idx) in parseOptions(scope.row)"
                :key="idx"
                v-if="op.image"
                style="position: relative;"
              >
                <el-image
                  :src="resolveImageUrl(op.image)"
                  fit="contain"
                  style="width: 50px; height: 50px; border: 1px solid #eee; border-radius: 4px;"
                  :preview-src-list="[resolveImageUrl(op.image)]"
                />
                <span style="position: absolute; top: -6px; left: -6px; background: #409eff; color: white; border-radius: 50%; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: bold;">{{ String.fromCharCode(65 + idx) }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="difficulty" label="难度" width="120" align="center">
          <template slot-scope="scope">{{ displayDifficulty(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="repoId" label="题库ID" width="90" align="center" />
        <el-table-column prop="uploader" label="上传者" min-width="120" show-overflow-tooltip />
        <el-table-column prop="url" label="URL" min-width="160">
          <template slot-scope="scope">
            <a v-if="scope.row.url" :href="scope.row.url" target="_blank">{{ scope.row.url }}</a>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="160">
          <template slot-scope="scope">{{ scope.row.createdAt || scope.row.createTime || '—' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container" style="margin-top: 10px;">
        <el-pagination
          :current-page="pageNum"
          :page-sizes="[10,20,30,40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="list.total || 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 编辑题目对话框 -->
    <el-dialog title="编辑题目" :visible.sync="editDialogVisible" width="700px">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="题目编号">
          <el-input v-model="editForm.number" />
        </el-form-item>
        <el-form-item label="题库ID">
          <el-input v-model="editForm.repoId" disabled />
        </el-form-item>
        <el-form-item label="题干(中文)">
          <el-input v-model="editForm.contentCn" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="题干(English)">
          <el-input v-model="editForm.contentEn" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="选项(中文)">
          <el-input v-model="editForm.optionsCn" type="textarea" :rows="4" placeholder="用分号分隔，图片使用 ![](图片路径) 格式" />
        </el-form-item>
        <el-form-item label="选项图片">
          <div style="display: flex; flex-wrap: wrap; gap: 12px; align-items: flex-end;">
            <div v-for="opt in ['A', 'B', 'C', 'D', 'E']" :key="opt" style="text-align: center; width: 80px;">
              <div style="font-size: 12px; color: #606266; margin-bottom: 4px;">{{ opt }}</div>
              <el-image
                v-if="optionImages[opt]"
                :src="resolveImageUrl(optionImages[opt])"
                :preview-src-list="[resolveImageUrl(optionImages[opt])]"
                style="width:60px;height:60px;object-fit:contain;border:1px solid #eee;margin-bottom:4px;cursor:pointer;"
              />
              <div v-else style="width:60px;height:60px;border:1px dashed #ddd;display:flex;align-items:center;justify-content:center;color:#ccc;font-size:12px;margin: 0 auto 4px;">无</div>
              <el-upload
                :action="'/api/file/uploadTo/amc-question-test'"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="(res) => handleOptionImageSuccess(opt, res)"
                accept="image/*"
              >
                <el-button size="mini" type="primary">上传</el-button>
              </el-upload>
              <el-button
                v-if="optionImages[opt]"
                size="mini"
                type="danger"
                plain
                style="margin-top: 4px;"
                @click="handleOptionImageRemove(opt)"
              >删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="选项(English)">
          <el-input v-model="editForm.optionsEn" type="textarea" :rows="4" placeholder="Separate by semicolons, use ![](url) for images" />
        </el-form-item>
        <el-form-item label="答案">
          <el-input v-model="editForm.answer" />
        </el-form-item>
        <el-form-item label="解析(中文)">
          <el-input v-model="editForm.analysisCn" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="解析(English)">
          <el-input v-model="editForm.analysisEn" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="知识点">
          <el-cascader
            v-model="editForm.knowledgeIds"
            placeholder="请选择知识点"
            clearable
            filterable
            :options="knowledgeOptions"
            :props="knowledgeCascaderProps"
            class="knowledge-cascader"
            style="width: 100%;"
            @change="handleEditKnowledgeChange"
          />
          <div v-if="editForm.knowledgeIds && editForm.knowledgeIds.length" class="knowledge-summary">
            已选：{{ selectedKnowledgeDisplay(editForm.knowledgeIds) }}
          </div>
        </el-form-item>
        <el-form-item label="难度">
          <el-input v-model="editForm.difficulty" placeholder="1-25的数字" />
        </el-form-item>
        <el-form-item label="年份">
          <el-input v-model="editForm.year" placeholder="如：2019" />
        </el-form-item>
        <el-form-item label="来源">
          <el-input v-model="editForm.source" placeholder="如：真题" />
        </el-form-item>
        <el-form-item label="URL">
          <el-input v-model="editForm.url" />
        </el-form-item>
        <el-form-item label="图片">
          <div v-if="editFormImageList.length > 0" style="margin-bottom: 10px;">
            <el-image
              v-for="(img, idx) in editFormImageList"
              :key="idx"
              :src="resolveImageUrl(img)"
              :preview-src-list="editFormImageList.map(i => resolveImageUrl(i))"
              style="width:80px;height:80px;object-fit:contain;margin-right:8px;"
            />
          </div>
          <file-upload-local ref="editImageUploader" :key="editImageUploaderKey" v-model="editFormNewImage" accept="image/*" list-type="picture" :limit="1" action-url="api/file/uploadTo/amc-question-test" bucket="amc-question-test" />
        </el-form-item>
        <el-form-item label="上传者">
          <el-input v-model="editForm.uploader" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-popconfirm v-if="editFormImageList.length > 0" title="确认删除所有图片吗？" @onConfirm="handleDeleteImage">
          <el-button slot="reference" type="danger">删除图片</el-button>
        </el-popconfirm>
        <el-button type="primary" @click="submitEdit">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 新增知识点对话框 -->
    <el-dialog title="新增知识点" :visible.sync="addKnowledgeDialogVisible" width="500px">
      <el-form label-width="100px">
        <el-form-item label="知识点名称">
          <el-input v-model="newKnowledgeName" placeholder="请输入知识点名称" />
        </el-form-item>
        <el-form-item label="父级知识点">
          <el-select
            v-model="newKnowledgeParentId"
            placeholder="留空则为顶级知识点"
            clearable
            filterable
            style="width: 100%;"
          >
            <el-option
              v-for="opt in flatKnowledgeOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addKnowledgeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddKnowledge">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 试卷预览弹窗 -->
    <el-dialog
      :title="`${query.year || ''}年 试卷预览（共 ${previewQuestions.length} 题）`"
      :visible.sync="previewDialogVisible"
      fullscreen
      :close-on-click-modal="false"
      custom-class="paper-preview-dialog"
    >
      <div slot="title" style="display:flex; align-items:center; justify-content:space-between; padding-right:40px;">
        <span style="font-size:16px; font-weight:600;">{{ query.year }}年 试卷预览（共 {{ previewQuestions.length }} 题）</span>
        <el-button type="primary" size="small" icon="el-icon-printer" @click="printPaper">打印 / 导出PDF</el-button>
      </div>
      <div v-loading="previewLoading" style="background:#e8e8e8; min-height:100%; padding:24px 0;">
        <div id="paper-print-area" class="a4-paper">
          <!-- 试卷标题 -->
          <div class="paper-header">
            <div class="paper-title">{{ repoTitle || 'AMC' }} {{ query.year }} 年试卷</div>
            <div class="paper-meta">共 {{ previewQuestions.length }} 题</div>
          </div>
          <div class="paper-divider"></div>

          <!-- 题目列表 -->
          <div v-for="(q, idx) in previewQuestions" :key="q.id || idx" class="paper-question">
            <!-- 题号 + 题干 -->
            <div class="pq-stem">
              <span class="pq-no">{{ idx + 1 }}.</span>
              <span v-html="renderMathFormula(q.contentCn || q.contentEn || q.content || '')"></span>
            </div>
            <!-- 题目图片 -->
            <div v-if="getFirstImage(q)" class="pq-img-wrap">
              <img :src="resolveImageUrl(getFirstImage(q))" class="pq-img" />
            </div>
            <!-- 选项 -->
            <div class="pq-options" v-if="parseOptions(q).length > 0">
              <div
                v-for="(opt, oidx) in parseOptions(q)"
                :key="oidx"
                class="pq-option"
              >
                <span v-html="renderOptionWithImage(opt)"></span>
              </div>
            </div>
          </div>

          <div v-if="!previewLoading && previewQuestions.length === 0" style="text-align:center; color:#999; padding:60px 0; font-size:15px;">
            {{ query.year ? `未找到 ${query.year} 年的题目，请先在查询栏选择年份并确认数据存在。` : '请先在查询栏选择年份后再预览。' }}
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 手动添加题目对话框 -->
    <el-dialog title="手动添加题目" :visible.sync="showManualForm" width="700px" :close-on-click-modal="false">
      <el-form ref="postForm" :model="postForm" :rules="rules" label-width="120px">
        <el-form-item label="归属题库" prop="repoId">
          <repo-select v-model="postForm.repoId" :multi="false" :disabled="!!$route.query.repoId" />
          <div v-if="$route.query.repoId" style="margin-top:6px; color:#909399; font-size:12px;">已根据题库列表选择：{{ repoTitle }}</div>
        </el-form-item>

        <el-form-item label="题目编号">
          <el-input v-model="postForm.number" placeholder="如：AMC820230101" />
        </el-form-item>

        <el-form-item label="题目标题">
          <el-input v-model="postForm.title" placeholder="题目标题（可选）" />
        </el-form-item>

        <el-form-item label="题干(中文)" prop="contentCn">
          <el-input v-model="postForm.contentCn" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="题干(English)">
          <el-input v-model="postForm.contentEn" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="选项">
          <div>
            <div v-for="(opt, idx) in postForm.options" :key="idx" style="margin-bottom:12px; padding:8px; background:#fafafa; border-radius:4px;">
              <div style="display:flex; align-items:center; gap:6px; margin-bottom:8px;">
                <span style="color:#909399; width:18px; font-weight:bold;">{{ String.fromCharCode(65 + idx) }}.</span>
                <el-input v-model="postForm.options[idx].text" placeholder="选项内容(中文)" style="flex:1;" />
                <el-button type="text" icon="el-icon-delete" style="color:#f56c6c;" @click="removeManualOption(idx)" />
              </div>
              <div style="margin-left:24px;">
                <el-input v-model="postForm.options[idx].textEn" placeholder="选项内容(English)" style="margin-bottom:6px;" />
              </div>
              <div style="margin-left:24px; margin-top:6px;">
                <div style="display:flex; align-items:center; gap:8px;">
                  <span style="font-size:12px; color:#909399;">选项图片:</span>
                  <file-upload-local
                    v-model="postForm.options[idx].image"
                    accept="image/*"
                    list-type="picture"
                    :limit="1"
                    action-url="api/file/uploadTo/amc-question-test"
                    bucket="amc-question-test"
                    style="display:inline-block;"
                  />
                </div>
                <div v-if="postForm.options[idx].image" style="margin-top:4px;">
                  <el-image
                    :src="resolveImageUrl(postForm.options[idx].image)"
                    fit="contain"
                    style="max-width:120px; max-height:80px; border:1px solid #eee; border-radius:4px;"
                    :preview-src-list="[resolveImageUrl(postForm.options[idx].image)]"
                  />
                </div>
              </div>
            </div>
            <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addManualOption">添加选项</el-button>
          </div>
        </el-form-item>

        <el-form-item label="答案">
          <el-input v-model="postForm.answer" placeholder="如：A 或 A;C" />
        </el-form-item>

        <el-form-item label="解析(中文)">
          <el-input v-model="postForm.analysisCn" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="解析(English)">
          <el-input v-model="postForm.analysisEn" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="知识点">
          <el-cascader
            v-model="postForm.knowledgeIds"
            placeholder="请选择知识点"
            clearable
            filterable
            :options="knowledgeOptions"
            :props="knowledgeCascaderProps"
            class="knowledge-cascader"
            style="width: 100%;"
          />
          <div v-if="postForm.knowledgeIds && postForm.knowledgeIds.length" class="knowledge-summary">
            已选：{{ selectedKnowledgeDisplay(postForm.knowledgeIds) }}
          </div>
        </el-form-item>

        <el-form-item label="难度">
          <el-input v-model="postForm.difficulty" placeholder="1-25的数字" />
        </el-form-item>

        <el-form-item label="年份">
          <el-input v-model="postForm.year" placeholder="如：2019" />
        </el-form-item>

        <el-form-item label="来源">
          <el-input v-model="postForm.source" placeholder="如：真题" />
        </el-form-item>

        <el-form-item label="标签">
          <el-input v-model="postForm.tags" placeholder="如：代数;几何" />
        </el-form-item>

        <el-form-item label="URL">
          <el-input v-model="postForm.url" placeholder="题目链接（可选）" />
        </el-form-item>

        <el-form-item label="图片">
          <file-upload-local v-model="postForm.image" accept="image/*" list-type="picture" :limit="1" action-url="api/file/uploadTo/amc-question-test" bucket="amc-question-test" />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showManualForm = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">保 存</el-button>
      </span>
    </el-dialog>
</div>
</template>

<script>
import { addQuestion, pagingByRepoId, saveQuestions, updateQuestion, batchDeleteQuestions, listYearsByRepoId } from '@/api/courseQuestion'
import { getTokenInfo } from '@/utils/jwtUtils'
import { getToken } from '@/utils/auth'
import katex from 'katex'
import 'katex/dist/katex.min.css'
import RepoSelect from '@/components/RepoSelect/index.vue'
import FileUploadLocal from '@/components/FileUpload/local.vue'
import { getGeneralKnowledgeByContent, createGeneralKnowledge, batchEnsureGeneralKnowledge, batchEnsureHierarchicalKnowledge, getGeneralKnowledgeById, listGeneralKnowledgeTree } from '@/api/knowledge'
import { processOcrImage, processPdfQuestions, getQuestions } from '@/api/ai'
import { deleteFrom } from '@/api/file'
import { getMinioUrl } from '@/utils/minio'

export default {
  components: { RepoSelect, FileUploadLocal },
  name: 'AMCAdd',
  created() {
    try {
      const q = this.$route && this.$route.query ? this.$route.query : {}
      console.log('[AMCAdd] current courseType for knowledge:', {
        resolvedCourseType: this.getCourseTypeForKnowledge(),
        routeCourseType: q.courseType || q.courseTypeId || q.courseTypeCode || '',
        repoId: this.query && this.query.repoId ? this.query.repoId : '',
        repoTitle: this.repoTitle || q.repoTitle || '',
        storageCourseType: localStorage.getItem('current_course_type_id') || ''
      })
    } catch (e) {}
    if (this.query.repoId) {
      this.fetchList()
      this.loadKnowledgeOptions()
    }
    this.generateYearOptions()
    this.generateFullYearOptions()
  },
  mounted() {
    // 双保险，确保下拉年份有数据（某些场景 keep-alive/缓存导致 created 未重跑）
    if (!this.yearOptions || this.yearOptions.length === 0) {
      this.generateYearOptions()
    }
    if (!this.fullYearOptions || this.fullYearOptions.length === 0) {
      this.generateFullYearOptions()
    }
  },
  activated() {
    // 被 keep-alive 缓存并再次激活时
    if (!this.yearOptions || this.yearOptions.length === 0) {
      this.generateYearOptions()
    }
    if (!this.fullYearOptions || this.fullYearOptions.length === 0) {
      this.generateFullYearOptions()
    }
  },
  data() {
    return {
      repoTitle: this.$route.query.repoTitle || '',
      loading: false,
      selectedRows: [],
      pageNum: 1,
      pageSize: 10,
      list: { records: [], total: 0, size: 10, current: 1 },
      query: {
        repoId: String(this.$route.query.repoId || ''),
        content: '',
        type: null,
        year: ''
      },
      showManualForm: false,
      // 导入对话框相关
      ocrImportDialogVisible: false,
      pdfImportDialogVisible: false,
      wordImportDialogVisible: false,
      ocrFileList: [],
      pdfFileList: [],
      wordFileList: [],
      importResultVisible: false,
      importType: 'ocr',
      // 识别结果
      ocrResults: [],
      pdfResults: [],
      wordResults: [],
      // 可编辑结果
      editResults: [],
      // AMC 级别
      amcLevels: [
        { value: 'AMC8', label: 'AMC8' },
        { value: 'AMC10', label: 'AMC10' },
        { value: 'AMC12', label: 'AMC12' }
      ],
      postForm: {
        repoId: String(this.$route.query.repoId || ''),
        number: '',
        title: '',
        contentCn: '',
        contentEn: '',
        options: [],
        answer: '',
        analysisCn: '',
        analysisEn: '',
        knowledgeIds: [],
        difficulty: '',
        year: '',
        source: '',
        tags: '',
        url: '',
        image: ''
      },
      knowledgeOptions: [],
      flatKnowledgeOptions: [],
      knowledgePathMap: {},
      knowledgeCascaderProps: {
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        value: 'id',
        label: 'content',
        children: 'children'
      },
      rules: {
        repoId: [{ required: true, message: '请选择题库' }],
        contentCn: [{ required: true, message: '题干(中文)不能为空' }]
      },
      // 编辑对话框
      editDialogVisible: false,
      editFormNewImage: '',
      editImageUploaderKey: 0,
      // 知识点ID缓存：key 形如 'parent||' 或 'parent||child' -> id
      _knowledgeIdCache: new Map(),
      // 仅用于显示的 id->name 映射
      _knowledgeIdNameMap: {},
      // 年份选项与批量设置
      yearOptions: [],
      fullYearOptions: [],
      bulkYear: '',
      previewDialogVisible: false,
      previewLoading: false,
      previewQuestions: [],
      editForm: {
        id: undefined,
        number: '',
        imagePaths: '',
        contentCn: '',
        contentEn: '',
        answer: '',
        analysisCn: '',
        analysisEn: '',
        repoId: '',
        courseId: null,
        uploader: '',
        knowledge: '',
        knowledgeIds: [],
        optionsCn: '',
        optionsEn: '',
        difficulty: '',
        year: '',
        source: '',
        url: ''
      },
      addKnowledgeDialogVisible: false,
      newKnowledgeName: '',
      newKnowledgeParentId: 0
    }
  },
  watch: {
    'query.repoId': {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loadKnowledgeOptions()
        }
      },
      immediate: false
    }
  },
  computed: {
    pagedRecords() {
      const records = (this.list && Array.isArray(this.list.records)) ? this.list.records : []
      // 如果后端已经按 pageNum/pageSize 分页返回当前页数据，则直接返回
      if (!this.list.total || records.length <= this.pageSize) {
        return records
      }
      // 否则在前端根据 pageNum/pageSize 再切一层，限制一次渲染的条数
      const start = (this.pageNum - 1) * this.pageSize
      const end = start + this.pageSize
      return records.slice(start, end)
    },
    normalizedResults() {
      let raw = []
      if (this.importType === 'pdf') {
        raw = this.pdfResults || []
      } else if (this.importType === 'word') {
        raw = this.wordResults || []
      } else {
        raw = this.ocrResults || []
      }
      return raw.map((item, idx) => {
        const contentEn = item.original_english_question || item.contentEn || item.content_en || ''
        const contentCn = item.chinese_translation || item.contentCn || item.content_cn || ''
        const analysisEn = item.english_explanation || item.analysisEn || item.analysis_en || ''
        const analysisCn = item.chinese_explanation || item.analysisCn || item.analysis_cn || ''
        const correctAnswer = item.correct_answer || item.answer || ''
        const tags = item.question_tags || item.tags || ''

        // 从 question_id 解析年份和难度
        const questionId = item.question_id || item.id || ''
        const { year: parsedYear, difficultyCode } = this.parseQuestionId(questionId)

        // 优先使用解析的年份，否则使用原字段
        const year = parsedYear || (item.year || item.examYear || item.exam_year || item.Year || '').toString()

        // 难度：优先使用解析的编码+标签格式
        let difficulty = ''
        if (difficultyCode) {
          const diffLabel = this.getDifficultyLabel(difficultyCode)
          difficulty = `${difficultyCode}(${diffLabel})`
        } else {
          // 兜底：尝试从 difficulty_level 字段获取，并转换为新格式
          let rawDiff = item.difficulty_level || item.difficulty
          // 如果是字符串如 "AMC8" 或已经是整数，直接使用
          if (typeof rawDiff === 'string') {
            // 尝试提取数字
            const numMatch = String(rawDiff).match(/\d+/)
            if (numMatch) {
              const num = parseInt(numMatch[0], 10)
              if (num >= 1 && num <= 25) {
                const label = this.getDifficultyLabel(String(num).padStart(2, '0'))
                difficulty = `${String(num).padStart(2, '0')}(${label})`
              } else {
                difficulty = rawDiff
              }
            } else {
              difficulty = rawDiff
            }
          } else if (typeof rawDiff === 'number') {
            // 如果是小数如 0.2，转换为新的整数系统
            if (rawDiff <= 1) {
              // 旧系统: 0-0.33=简单, 0.34-0.66=中等, 0.67+=困难
              // 映射到新系统: 1-8, 9-16, 17-25
              let code
              if (rawDiff <= 0.33) code = '04' // 简单中间值
              else if (rawDiff <= 0.66) code = '12' // 中等中间值
              else code = '20' // 困难中间值
              const label = this.getDifficultyLabel(code)
              difficulty = `${code}(${label})`
            } else if (rawDiff >= 1 && rawDiff <= 25) {
              // 已经是新格式的整数
              const code = String(Math.round(rawDiff)).padStart(2, '0')
              const label = this.getDifficultyLabel(code)
              difficulty = `${code}(${label})`
            } else {
              difficulty = String(rawDiff)
            }
          } else {
            difficulty = '05(简单)' // 默认值
          }
        }

        const stem = item.stem || item.content || item.question || contentCn || contentEn || ''
        const options = Array.isArray(item.options)
          ? item.options
          : Array.isArray(item.choices)
            ? item.choices
            : []
        // 优先读取 markdown 返回的中文选项 chinese_options（如果有）
        const cnOptions = Array.isArray(item.chinese_options) ? item.chinese_options : null
        const image = item.image || item.img || item.url || ''

        return {
          question_id: questionId || idx + 1,
          stem,
          options,
          // 保留中文选项供保存阶段使用（不渲染单独列）
          cnOptions,
          contentEn,
          contentCn,
          analysisEn,
          analysisCn,
          correctAnswer,
          tags,
          difficulty,
          image,
          year
        }
      })
    },
    hasSelection() {
      return this.selectedRows && this.selectedRows.length > 0
    },
    uploadHeaders() {
      return { Authorization: getToken() }
    },
    editFormImageList() {
      // 解析 imagePaths JSON 字符串为数组
      return this.parseImagePaths(this.editForm.imagePaths || this.editForm.image_paths)
    },
    // 从选项文本或 optionImages 字段中提取 ABCDE 各选项的图片 URL
    optionImages() {
      const result = { A: '', B: '', C: '', D: '', E: '' }

      // 1. 优先尝试从 optionsCn 文本中的 Markdown 图片语法提取
      const optStr = this.editForm.optionsCn || ''
      if (optStr) {
        const options = optStr.split(';')
        for (const opt of options) {
          const letterMatch = opt.match(/^\s*\(?([A-E])\)?[\.\:\s]/i)
          if (letterMatch) {
            const letter = letterMatch[1].toUpperCase()
            const imgMatch = opt.match(/!\[[^\]]*\]\(([^)]+)\)/)
            if (imgMatch) {
              result[letter] = imgMatch[1]
            }
          }
        }
      }

      // 2. 如果文本中没有提取到，且存在 optionImages 字段（分号分隔的图片路径），则按顺序填充
      // 注意：optionImages 字段通常是按 A,B,C,D,E 顺序存储的图片路径，若某选项无图可能是空字符串
      if (Object.values(result).every(v => !v) && this.editForm.optionImages) {
        const imgs = this.editForm.optionImages.split(';')
        const letters = ['A', 'B', 'C', 'D', 'E']
        imgs.forEach((img, idx) => {
          if (img && idx < letters.length) {
            result[letters[idx]] = img
          }
        })
      }

      return result
    }
  },
  methods: {
    resolveCourseTypeIdByCode(raw) {
      const value = String(raw || '').trim()
      if (!value) return ''
      if (/^\d+$/.test(value)) return value
      const upper = value.toUpperCase()
      if (upper.includes('GESP')) return '4'
      if (upper.includes('KANGAROO') || value.includes('袋鼠')) return '3'
      if (upper.includes('AMC')) return '2'
      return ''
    },
    getCourseTypeForKnowledge() {
      const q = this.$route && this.$route.query ? this.$route.query : {}
      const fromQuery = this.resolveCourseTypeIdByCode(q.courseType || q.courseTypeId || q.courseTypeCode)
      if (fromQuery) return fromQuery
      const fromRepoTitle = this.resolveCourseTypeIdByCode(this.repoTitle || q.repoTitle)
      if (fromRepoTitle) return fromRepoTitle
      try {
        const fromStorage = localStorage.getItem('current_course_type_id')
        const resolvedStorage = this.resolveCourseTypeIdByCode(fromStorage)
        if (resolvedStorage) return resolvedStorage
      } catch (e) {}
      return '2'
    },
    // 处理选项图片上传成功
    handleOptionImageSuccess(letter, res) {
      // 从响应中提取图片路径
      let imagePath = ''
      const bucket = 'amc-question-test'
      if (res) {
        // 优先使用 path 字段（相对路径）
        if (res.data && res.data.path) {
          imagePath = res.data.path
        } else if (res.data && typeof res.data === 'string') {
          imagePath = res.data
        } else if (res.path) {
          imagePath = res.path
        }
      }

      if (imagePath) {
        // 如果是完整URL，提取路径部分
        if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
          try {
            const url = new URL(imagePath)
            imagePath = url.pathname
          } catch (e) {
            // 保持原值
          }
        }
        // 确保路径格式为 /bucket/key
        if (!imagePath.startsWith('/')) {
          imagePath = `/${bucket}/${imagePath}`
        } else if (!imagePath.startsWith(`/${bucket}/`)) {
          // 如果已经是 /xxx/yyy 格式但不是正确的 bucket，保持原样
        }
        this.setOptionImage(letter, imagePath)
        this.$message.success(`选项 ${letter} 图片上传成功`)
      } else {
        this.$message.error('上传失败：' + (res && res.msg || '未知错误'))
      }
    },
    handleOptionImageRemove(letter) {
      this.setOptionImage(letter, '')
      this.$message.success(`已删除选项 ${letter} 图片`)
    },
    updateOptionImagesField(letter, imageUrl) {
      const letters = ['A', 'B', 'C', 'D', 'E']
      const idx = letters.indexOf(String(letter || '').toUpperCase())
      if (idx < 0) return
      const arr = String(this.editForm.optionImages || '').split(';')
      while (arr.length < letters.length) arr.push('')
      arr[idx] = imageUrl || ''
      let end = arr.length - 1
      while (end >= 0 && !arr[end]) end -= 1
      this.editForm.optionImages = end >= 0 ? arr.slice(0, end + 1).join(';') : ''
    },
    // 设置选项图片并更新选项文本
    setOptionImage(letter, imageUrl) {
      const optStr = this.editForm.optionsCn || ''
      const options = optStr.split(';').map(o => o.trim()).filter(o => o)

      // 查找对应选项
      let found = false
      const newOptions = options.map(opt => {
        const letterMatch = opt.match(/^\s*\(?([A-E])\)?[\.\:\s]/i)
        if (letterMatch && letterMatch[1].toUpperCase() === letter) {
          found = true
          // 移除旧图片
          let newOpt = opt.replace(/!\[[^\]]*\]\([^)]+\)/g, '').trim()
          // 添加新图片
          if (imageUrl) {
            // 在选项字母后插入图片
            const prefix = newOpt.match(/^\s*\(?[A-E]\)?[\.\:\s]*/i)
            if (prefix) {
              newOpt = prefix[0] + `![](${imageUrl})` + newOpt.substring(prefix[0].length)
            } else {
              newOpt = `(${letter}) ![](${imageUrl})`
            }
          }
          return newOpt
        }
        return opt
      })

      // 如果没找到该选项，添加新选项
      if (!found && imageUrl) {
        newOptions.push(`(${letter}) ![](${imageUrl})`)
      }

      this.editForm.optionsCn = newOptions.join(';')
      this.updateOptionImagesField(letter, imageUrl)
    },
    // 获取行的第一张图片（兼容 imagePaths 和 image 字段）
    getFirstImage(row) {
      const arr = this.getImageList(row)
      return arr.length > 0 ? arr[0] : ''
    },
    // 获取行的所有图片列表
    getImageList(row) {
      if (!row) return []
      const paths = this.parseImagePaths(row.imagePaths || row.image_paths)
      if (paths.length > 0) return paths
      return this.parseImagePaths(row.image)
    },
    parseImagePaths(value) {
      if (!value) return []
      if (Array.isArray(value)) return value.map(item => String(item || '').trim()).filter(Boolean)
      const raw = String(value).trim()
      if (!raw) return []
      if (raw.startsWith('[') || raw.startsWith('{')) {
        try {
          const parsed = JSON.parse(raw)
          if (Array.isArray(parsed)) return parsed.map(item => String(item || '').trim()).filter(Boolean)
          if (typeof parsed === 'string') return parsed.trim() ? [parsed.trim()] : []
        } catch (e) {}
      }
      return raw.split(/[;,]/).map(item => item.trim()).filter(Boolean)
    },

    // 解析选项字符串为数组，返回对象数组 { text: string, image: string }
    parseOptions(row) {
      const optStr = row.optionsCn || row.options_en || row.optionsEn || row.options || ''
      if (!optStr) return []

      const segments = String(optStr).split(';').map(s => String(s).trim()).filter(Boolean)

      // 尝试获取对应的选项图片（后备：当段落中没有 Markdown 图片时使用）
      let optionImages = []
      const imgStr = row.optionImages || row.option_images
      if (imgStr) {
        optionImages = String(imgStr).split(';').map(s => String(s).trim()).filter(Boolean)
      }

      // 由于部分数据会把“描述选项 A-E”和“图片选项 A-C”拼在一起
      // 这里按选项字母(A-E)聚合，把文本与图片合并到同一个选项对象，避免多出 (A)(B)(C) 与图片索引变成 F/G/H
      const letterMap = new Map()
      const ensure = (letter) => {
        if (!letterMap.has(letter)) {
          letterMap.set(letter, { text: '', image: '' })
        }
        return letterMap.get(letter)
      }

      segments.forEach((seg) => {
        const m = seg.match(/^\s*\(?([A-E])\)?/i)
        if (!m) return
        const letter = String(m[1]).toUpperCase()
        const rec = ensure(letter)

        // 1) 提取 Markdown 图片（若存在）
        const imgMatch = seg.match(/!\[[^\]]*\]\(([^)]+)\)/)
        if (imgMatch && imgMatch[1] && !rec.image) {
          rec.image = imgMatch[1]
        }

        // 2) 处理文本：移除 Markdown 图片语法，但保留其它内容（例如“(A)（对应题目图示选项 A）”）
        const textOnly = seg.replace(/!\[[^\]]*\]\([^)]+\)/g, '').trim()
        // 如果文本仅剩下 “(A)” 或 “A.” 之类的占位，不要当成一条独立选项文本
        const placeholderOnly = /^\s*\(?[A-E]\)?[\.:\s]*$/i.test(textOnly)
        if (!placeholderOnly) {
          if (rec.text) {
            // 避免重复拼接同一段文本
            if (rec.text !== textOnly) rec.text = rec.text + ' ' + textOnly
          } else {
            rec.text = textOnly
          }
        }
      })

      // 后备：如果没有从段落里解析到图片，则按 A-E 顺序用 optionImages 补齐
      ;['A', 'B', 'C', 'D', 'E'].forEach((letter, idx) => {
        const rec = letterMap.get(letter)
        if (!rec) return
        if (!rec.image && idx < optionImages.length && optionImages[idx]) {
          rec.image = optionImages[idx]
        }
      })

      // 按 A-E 输出，确保 idx 与字母一致，从而“选项图片”列不会出现 F/G/H
      return ['A', 'B', 'C', 'D', 'E']
        .filter(letter => letterMap.has(letter))
        .map(letter => letterMap.get(letter))
    },
    // 渲染选项，支持 Markdown 图片语法 ![alt](url) 和单独传入的 image
    renderOptionWithImage(option) {
      // 兼容传入字符串的情况
      const optionText = typeof option === 'string' ? option : (option ? option.text : '')
      const optionImage = typeof option === 'object' ? option.image : ''

      if (!optionText && !optionImage) return ''

      let text = String(optionText)
      // 移除"对应题目图示选项 X"等描述文字
      text = text.replace(/\(对应题目图示选项\s*[A-E]\)/gi, '')
      text = text.replace(/对应题目图示选项\s*[A-E]/gi, '')

      // 匹配 Markdown 图片语法: ![alt](url)，将图片渲染为img标签
      const imgRegex = /!\[([^\]]*)\]\(([^)]+)\)/g
      const hasMarkdownImage = imgRegex.test(text)
      imgRegex.lastIndex = 0 // 重置正则状态

      // 如果文本中已有 Markdown 图片，先渲染它
      let html = text.replace(imgRegex, (match, alt, url) => {
        const resolvedUrl = this.resolveImageUrl(url)
        return `<img src="${resolvedUrl}" alt="${alt}" style="max-width:100px;max-height:60px;vertical-align:middle;margin:2px;" />`
      })

      // 只有当文本中没有 Markdown 图片，且有单独的 image 字段时，才追加图片
      // 这样避免了图片重复显示的问题
      if (optionImage && !hasMarkdownImage) {
        const resolvedUrl = this.resolveImageUrl(optionImage)
        const imgTag = `<img src="${resolvedUrl}" style="max-width:100px;max-height:60px;vertical-align:middle;margin:2px;" />`
        // 如果文本是空的，直接显示图片；否则追加到文本后
        if (!html.trim()) {
            html = imgTag
        } else {
            html = html + ' ' + imgTag
        }
      }

      // 移除空括号 ()
      html = html.replace(/\(\s*\)/g, '')
      // 清理多余空格
      html = html.replace(/\s+/g, ' ').trim()

      // 然后渲染数学公式
      return this.renderMathFormula(html)
    },
    // 只渲染选项文本，不包含图片（用于选项列显示）
    renderOptionTextOnly(option) {
      const optionText = typeof option === 'string' ? option : (option ? option.text : '')
      if (!optionText) return ''

      let text = String(optionText)
      // 移除 Markdown 图片语法 ![alt](url)
      text = text.replace(/!\[[^\]]*\]\([^)]+\)/g, '')
      // 移除空括号 ()
      text = text.replace(/\(\s*\)/g, '')
      // 清理多余空格
      text = text.replace(/\s+/g, ' ').trim()

      // 渲染数学公式
      return this.renderMathFormula(text)
    },
    // 列表年份展示：优先 row.year，否则从编号 number 解析（如 AMC08200015A -> 2000）
    displayYear(row) {
      if (!row) return '—'
      if (row.year) return row.year
      const num = row.number ? String(row.number) : ''
      // 尝试复用 question_id 解析逻辑
      const qid = num || String(row.id || '')
      const parsed = this.parseQuestionId(qid)
      return parsed.year || '—'
    },
    // 列表难度展示：优先从编号(number)末两位，其次 difficulty 字段提取数字
    displayDifficulty(row) {
      if (!row) return '—'
      // 1. 优先使用 row.difficulty 字段（如果是有效数字且在 1-25 范围内）
      if (row.difficulty) {
        const dMatch = String(row.difficulty).match(/(\d{1,2})/)
        if (dMatch) {
          const num = parseInt(dMatch[1], 10)
          if (!isNaN(num) && num >= 1 && num <= 25) {
            const code = String(num).padStart(2, '0')
            const label = this.getDifficultyLabel(code)
            return `${code}(${label})`
          }
        }
      }

      // 2. 如果 difficulty 字段无效，尝试从 number 字段解析
      // 支持 AMC 格式: ...(\d{2})[A-Z]?$  (末尾两位数字，可能有字母后缀)
      // 支持 GESP/KG 格式: ...(\d{2})[A-Z]?$ (类似逻辑，取末尾数字)
      const numStr = row.number ? String(row.number) : ''
      let code = ''
      // 尝试匹配末尾的题号 (排除年份后的数字)
      // AMC08202301A -> 01
      // KGL1201303A -> 03
      // GESP320230605 -> 05

      // 通用策略：提取末尾的 1-2 位数字（允许后面跟一个字母）
      const m = numStr.match(/(\d{1,2})([A-Z])?$/i)
      if (m) {
        code = m[1].padStart(2, '0')
      }

      if (!code) return '—'
      const label = this.getDifficultyLabel(code)
      return `${code}(${label})`
    },
    // 从 question_id 解析年份和难度编号
    // 格式示例:
    // AMC08198801A -> year=1988, difficultyCode=01
    // GESP320230605 -> year=2023, difficultyCode='' (GESP[等级1位][年份4位][月份2位][题号2位])
    // KGL1201301A -> year=2013, difficultyCode='' (KG[Level][Year][Num][Paper])
    parseQuestionId(qid) {
      if (!qid || typeof qid !== 'string') return { year: '', difficultyCode: '' }

      // 匹配 GESP 格式: GESP[等级1位][年份4位][月份2位][题号2位]
      const gespMatch = qid.match(/^GESP\d(\d{4})\d{4}$/i)
      if (gespMatch) {
        return {
          year: gespMatch[1],
          difficultyCode: ''
        }
      }

      // 匹配 AMC 格式: AMC[级别][年份4位][难度2位][字母]
      const amcMatch = qid.match(/AMC\d+(\d{4})(\d{2})[A-Z]?$/i)
      if (amcMatch) {
        return {
          year: amcMatch[1],
          difficultyCode: amcMatch[2]
        }
      }

      // 匹配 KG (袋鼠数学) 格式: KG[Level][Year][Num][Paper]
      // 例如 KGL1201301A -> L1 (Level), 2013 (Year), 01 (Num), A (Paper)
      const kgMatch = qid.match(/^KG[A-Z0-9]+(\d{4})\d{2}[A-Z]?$/i)
      if (kgMatch) {
        return {
          year: kgMatch[1],
          difficultyCode: ''
        }
      }

      return { year: '', difficultyCode: '' }
    },
    // 根据难度编号返回中文标签
    getDifficultyLabel(code) {
      const num = parseInt(code, 10)
      if (num >= 1 && num <= 8) return '简单'
      if (num >= 9 && num <= 16) return '中等'
      if (num >= 17 && num <= 25) return '困难'
      return '未知'
    },
    resolveImageUrl(path) {
      if (!path) return ''
      let s = String(path)

      // 如果是完整的 MinIO URL，提取路径部分
      if (s.startsWith('http://') || s.startsWith('https://')) {
        try {
          const url = new URL(s)
          // 提取 pathname，如 /amc-question-test/xxx.png
          s = url.pathname
        } catch (e) {
          // 如果解析失败，直接返回原 URL
          return s
        }
      }

      // 已是后端预览路径
      if (s.startsWith('/api/file/preview')) return s
      // 若是 bucket 相对路径，如 /amc-question-test/xxx.png -> 使用预览接口
      if (/^\/[A-Za-z0-9_-]+\//.test(s)) {
        return `/api/file/preview?path=${encodeURIComponent(s)}`
      }
      // 其它相对路径，回退到后端代理拼接
      const base = process.env.VUE_APP_BASE_API || ''
      try {
        const absBase = /^(https?:)?\/\//i.test(base)
          ? base
          : (window.location.origin + (base.startsWith('/') ? base : ('/' + base)))
        const url = new URL(s, absBase)
        return url.toString()
      } catch (_) {
        let out = base ? (base.replace(/\/$/, '') + '/' + s.replace(/^\//, '')) : s
        return out
      }
    },
    extractImageObjectKey(u) {
      if (!u) return ''
      const s = String(u)
      const m = s.match(/\/api\/file\/[^/]+\/(.+)$/)
      if (m && m[1]) return decodeURIComponent(m[1])
      const parts = s.split('?')[0].split('#')[0].split('/')
      return parts.length ? parts[parts.length - 1] : ''
    },
    async handleDeleteImage() {
      const bucket = 'amc-question-test'
      const images = this.editFormImageList
      if (!images || images.length === 0) {
        this.$message.error('未找到可删除的文件')
        return
      }
      try {
        for (const img of images) {
          const key = this.extractImageObjectKey(img)
          if (key) {
            await deleteFrom(bucket, key)
          }
        }
        this.editForm.imagePaths = ''
        this.resetEditImageUploader()
        this.$message.success('已删除所有图片文件')
      } catch (e) {
        this.$message.error('删除失败：' + (e.message || '未知错误'))
      }
    },

    resetEditImageUploader() {
      this.editFormNewImage = ''
      const uploadComp = this.$refs.editImageUploader
      const uploadRef = Array.isArray(uploadComp) ? uploadComp[0] : uploadComp
      const innerUpload = uploadRef && uploadRef.$refs ? uploadRef.$refs.uploadRef : null
      if (innerUpload && innerUpload.clearFiles) {
        innerUpload.clearFiles()
      }
      this.editImageUploaderKey += 1
    },

    goBack() {
      this.$router.push({ name: 'questions-management', query: { repoId: this.$route.query.repoId, repoTitle: this.$route.query.repoTitle } })
    },
    handleRepoChange(val) {
      // val 可能是对象 {id, title} 或者直接是 id
      const rawId = val && typeof val === 'object' ? val.id : val
      const rawTitle = val && typeof val === 'object' ? val.title : ''
      // 确保 repoId 是字符串类型（RepoSelect 组件要求）
      const repoId = rawId != null ? String(rawId) : ''
      this.repoTitle = rawTitle || this.repoTitle || ''
      // 同步到新增表单
      this.query.repoId = repoId
      this.postForm.repoId = repoId
      this.pageNum = 1
      this.fetchList()
      this.clearSelection()
    },
    handleOcrFileChange(file, fileList) {
      this.ocrFileList = fileList
    },
    handleOcrFileRemove(file, fileList) {
      this.ocrFileList = fileList
    },
    async submitOcrFiles() {
      if (!this.query.repoId) {
        this.$message.warning('请先选择题库')
        return
      }
      if (!this.ocrFileList || this.ocrFileList.length === 0) {
        this.$message.warning('请先选择图片文件')
        return
      }
      this.importType = 'ocr'
      this.ocrResults = []
      try {
        for (let i = 0; i < this.ocrFileList.length; i++) {
          const f = this.ocrFileList[i]
          const formData = new FormData()
          formData.append('image', f.raw)
          const resp = await processOcrImage(formData)
          const payload = (resp && resp.data) || resp || {}
          // 兼容多种返回结构
          const arr = payload.results || payload.data || payload.items || []
          if (Array.isArray(arr)) {
            this.ocrResults.push(...arr)
          }
        }
        this.ocrImportDialogVisible = false
        this.importResultVisible = true
        this.resetEditedResults()
      } catch (e) {
        this.$message.error('OCR识别失败：' + (e.message || '未知错误'))
      }
    },
    // 专用于 question_tags 单层词语 -> knowledge ID 的解析
    // question_tags 格式: "图形观察、数字认知" (顿号分隔)
    async resolveTagsToKnowledgeIds(rows) {
      if (!rows || rows.length === 0) return

      // 1. 收集所有不重复的词语（支持顿号、逗号、分号等分隔符）
      const allTags = new Set()
      rows.forEach(row => {
        const tagsStr = row.tags || ''
        if (!tagsStr) return
        String(tagsStr).split(/[、，,;；]+/).map(s => s.trim()).filter(Boolean).forEach(t => allTags.add(t))
      })
      if (allTags.size === 0) return

      // 2. 构建 pairs 列表（每个词语作为父级，child 为空）
      const pairs = Array.from(allTags).map(tag => ({ parent: tag, child: '' }))

      // 3. 调用 batchEnsure，确保知识点存在并取得 id
      let tagNameToId = {}
      try {
        const resp = await batchEnsureGeneralKnowledge(pairs, undefined, this.query.repoId, this.getCourseTypeForKnowledge())
        const data = (resp && resp.data) || resp || {}
        const parents = data.parents || {}
        Object.keys(parents).forEach(name => {
          const rec = parents[name] || {}
          const id = rec.id || rec.ID
          if (id) {
            tagNameToId[name] = id
            // 同步更新 _knowledgeIdNameMap，用于显示时 ID→名称 的转换
            this.$set(this._knowledgeIdNameMap, String(id), name)
          }
        })
      } catch (e) {
        console.error('batchEnsure 知识点失败:', e)
        return
      }

      // 4. 回填每行的 knowledge 字段（逗号分隔的 ID 字符串）
      rows.forEach(row => {
        const tagsStr = row.tags || ''
        if (!tagsStr) return
        const ids = String(tagsStr)
          .split(/[、，,;；]+/)
          .map(s => s.trim())
          .filter(Boolean)
          .map(tag => tagNameToId[tag])
          .filter(id => id != null)
        if (ids.length > 0) {
          this.$set(row, 'knowledge', ids.join(','))
        }
      })
    },

    async buildKnowledgeIdCache(rows) {
      this._knowledgeIdCache = new Map()
      // 1) 汇总唯一父/子对
      const pairs = []
      const hierarchies = []
      const seen = new Set()
      const seenHierarchies = new Set()

      rows.forEach(r => {
        const ps = this.parseTagsToPairs(r.tags)
        ps.forEach(({ parent, child, hierarchy, levels }) => {
          if (!parent) return

          // 如果是多层级（3层或以上），使用新的hierarchies API
          if (levels && levels.length >= 3) {
            if (!seenHierarchies.has(hierarchy)) {
              seenHierarchies.add(hierarchy)
              hierarchies.push(hierarchy)
            }
          } else {
            // 两层结构使用旧的pairs API
            const key = parent + '|||' + (child || '')
            if (!seen.has(key)) {
              seen.add(key)
              pairs.push({ parent, child })
            }
          }
        })
      })

      if (pairs.length === 0 && hierarchies.length === 0) return

      // 2) 调用批量确保API
      let resp
      try {
        // 优先使用新的hierarchies API（支持多层级）
        if (hierarchies.length > 0) {
          resp = await batchEnsureHierarchicalKnowledge(hierarchies, undefined, this.query.repoId, this.getCourseTypeForKnowledge())
        } else {
          // 兼容旧的pairs API（两层结构）
          resp = await batchEnsureGeneralKnowledge(pairs, undefined, this.query.repoId, this.getCourseTypeForKnowledge())
        }
      } catch (e) {
        resp = null
      }
      const data = (resp && resp.data) || resp || {}

      // 修复：确保 parents 和 children 存在且为对象
      const parents = data.parents || {}
      Object.keys(parents).forEach(parentName => {
        const rec = parents[parentName] || {}
        const pid = rec.id || rec.ID
        if (pid) this._knowledgeIdCache.set(parentName + '||', pid)
      })

      const children = data.children || {}
      Object.keys(children).forEach(joined => {
        const rec = children[joined] || {}
        const cid = rec.id || rec.ID
        if (!cid) return
        // 注意：后端返回的键可能是 "ParentName|ChildName" 格式
        const parts = String(joined).split('|')
        if (parts.length >= 2) {
          const parentName = parts[0]
          const childName = parts.slice(1).join('|')
          this._knowledgeIdCache.set(parentName + '||' + childName, cid)
        }
      })
    },
    // 从缓存解析单题的ID数组
    getKnowledgeIdsFromCache(tags) {
      // 确保 _knowledgeIdCache 已初始化
      if (!this._knowledgeIdCache) {
        this._knowledgeIdCache = new Map()
      }

      const ps = this.parseTagsToPairs(tags)
      if (!ps || ps.length === 0) return []
      const ids = []
      ps.forEach(({ parent, child }) => {
        if (!parent) return
        const pid = this._knowledgeIdCache.get(parent + '||') || 0
        if (child) {
          const cid = this._knowledgeIdCache.get(parent + '||' + child) || 0
          // 子知识点优先保留（保持与原先 knowledgeId 取首项的一致性），同时补充父级ID
          if (cid) ids.push(cid)
          if (pid) ids.push(pid)
        } else if (pid) {
          ids.push(pid)
        }
      })
      // 去重并保持先出现的顺序
      return Array.from(new Set(ids))
    },
    handlePdfFileChange(file, fileList) {
      this.pdfFileList = fileList.slice(-1)
    },
    handlePdfFileRemove(file, fileList) {
      this.pdfFileList = fileList
    },
    handleWordFileChange(file, fileList) {
      this.wordFileList = fileList.slice(-1)
    },
    handleWordFileRemove(file, fileList) {
      this.wordFileList = fileList
    },
    async generateYearOptions() {
      // 动态从后端拉取当前题库的年份列表；失败时回退到默认范围
      try {
        if (this.query.repoId) {
          const resp = await listYearsByRepoId(this.query.repoId)
          const data = (resp && resp.data) || resp || []
          const years = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : [])
          if (Array.isArray(years) && years.length > 0) {
            this.yearOptions = years.map(String).sort((a,b) => Number(b) - Number(a))
            return
          }
        }
      } catch (e) {}
      const now = new Date().getFullYear()
      const start = 1985
      const arr = []
      for (let y = now; y >= start; y--) arr.push(String(y))
      if (arr.length === 0 && Array.isArray(this.normalizedResults)) {
        const set = new Set()
        this.normalizedResults.forEach(r => { if (r.year) set.add(String(r.year)) })
        this.yearOptions = Array.from(set).sort((a,b) => Number(b) - Number(a))
      } else {
        this.yearOptions = arr
      }
    },
    generateFullYearOptions() {
      const now = new Date().getFullYear()
      const start = 1985
      const arr = []
      for (let y = now; y >= start; y--) arr.push(String(y))
      this.fullYearOptions = arr
    },
    applyBulkYear() {
      if (!this.bulkYear) return
      const y = String(this.bulkYear)
      this.editResults.forEach(r => { r.year = y })
    },
    async submitWordFile() {
      if (!this.query.repoId) {
        this.$message.warning('请先选择题库')
        return
      }
      if (!this.wordFileList || this.wordFileList.length === 0) {
        this.$message.warning('请先选择 Word/Markdown 文件')
        return
      }
      try {
        const formData = new FormData()
        formData.append('md_file', this.wordFileList[0].raw)
        const resp = await getQuestions(formData)
        const payload = (resp && resp.data) || resp || {}
        const arr = Array.isArray(payload)
          ? payload
          : (payload.data || payload.results || payload.questions || payload.problems || [])
        this.wordResults = Array.isArray(arr) ? arr : []
        this.wordImportDialogVisible = false
        this.importType = 'word'

        // 确保年份选项存在
        if (!this.yearOptions || this.yearOptions.length === 0) {
          this.generateYearOptions()
        }

        // 重置编辑结果（此处会从 wordResults 映射到 editResults，包含 tags）
        this.resetEditedResults()

        // 核心修复：基于 tags 预解析知识点 ID 并填充到 editResults 的 knowledge 字段
        // question_tags 来自 parse_md_unified，是逗号分隔的单层词语（如"正方形阵列计数,图形观察"）
        // 需要调用 batchEnsure 接口，从 parents 返回的 id 映射中获取对应 ID
        try {
          await this.resolveTagsToKnowledgeIds(this.editResults)
        } catch (e) {
          console.error('知识点预处理失败:', e)
        }

        this.importResultVisible = true
      } catch (e) {
        const msg = (e && e.response && (e.response.data && (e.response.data.msg || e.response.data.message || JSON.stringify(e.response.data)))) ||
          (e && e.message) ||
          '未知错误'
        console.error('[submitWordFile] failure:', e)
        this.$message.error('Word解析失败：' + msg)
      }
    },
    async submitPdfFile() {
      if (!this.query.repoId) {
        this.$message.warning('请先选择题库')
        return
      }
      if (!this.pdfFileList || this.pdfFileList.length === 0) {
        this.$message.warning('请先选择PDF文件')
        return
      }
      try {
        const formData = new FormData()
        formData.append('pdf_file', this.pdfFileList[0].raw)
        const resp = await processPdfQuestions(formData)
        const payload = (resp && resp.data) || resp || {}
        const arr = payload.data || payload.results || payload.questions || []
        this.pdfResults = Array.isArray(arr) ? arr : []
        this.pdfImportDialogVisible = false
        this.importType = 'pdf'
        this.importResultVisible = true
        this.resetEditedResults()
      } catch (e) {
        this.$message.error('PDF解析失败：' + (e.message || '未知错误'))
      }
    },
    parseTagsToPairs(tagsStr) {
      if (!tagsStr) return []
      const parts = String(tagsStr).split(/[，,;；]/).map(s => s.trim()).filter(Boolean)
      const out = []
      const seen = new Set()
      parts.forEach(seg => {
        const arr = seg.split('-').map(s => s.trim()).filter(Boolean)
        if (arr.length === 0) return

        // 支持多层级：如果有3层或更多，保存完整路径用于新API
        if (arr.length >= 3) {
          const key = arr.join('-')
          if (seen.has(key)) return
          seen.add(key)
          out.push({ parent: arr[0], child: arr[1], hierarchy: seg, levels: arr })
        } else if (arr.length === 2) {
          // 兼容旧的两层结构
          const parent = arr[0] || ''
          const child = arr[1] || ''
          const key = parent + '|||' + child
          if (seen.has(key)) return
          seen.add(key)
          out.push({ parent, child, hierarchy: seg, levels: arr })
        } else if (arr.length === 1) {
          // 新增：支持单层结构（只有父节点）
          const parent = arr[0]
          const key = parent + '|||'
          if (seen.has(key)) return
          seen.add(key)
          out.push({ parent, child: '', hierarchy: seg, levels: arr })
        }
      })
      return out
    },
    async ensureKnowledgePair(pair) {
      const { parent, child } = pair
      let parentId = 0
      try {
        const rp = await getGeneralKnowledgeByContent(parent, 0, this.query.repoId, this.getCourseTypeForKnowledge())
        const pdata = (rp && rp.data) || rp || null
        if (pdata) {
          if (Array.isArray(pdata)) {
            parentId = (pdata[0] && (pdata[0].id || pdata[0].ID)) || 0
          } else {
            parentId = pdata.id || pdata.ID || 0
          }
        }
      } catch (e) {
        parentId = 0
      }
      if (!parentId) {
        const cr = await createGeneralKnowledge({ content: parent, parentId: 0, repoId: this.query.repoId, courseType: this.getCourseTypeForKnowledge() })
        const cdata = (cr && cr.data) || cr || {}
        parentId = cdata.id || cdata.ID || parentId
      }
      if (child) {
        let childId = 0
        try {
          const rc = await getGeneralKnowledgeByContent(child, parentId, this.query.repoId, this.getCourseTypeForKnowledge())
          const cdata2 = (rc && rc.data) || rc || null
          if (cdata2) {
            if (Array.isArray(cdata2)) {
              childId = (cdata2[0] && (cdata2[0].id || cdata2[0].ID)) || 0
            } else {
              childId = cdata2.id || cdata2.ID || 0
            }
          }
        } catch (e) {
          childId = 0
        }
        if (!childId) {
          await createGeneralKnowledge({ content: child, parentId, repoId: this.query.repoId, courseType: this.getCourseTypeForKnowledge() })
        }
      }
    },
    async ensureAllKnowledge(rows) {
      const pairs = []
      const hierarchies = []
      const seen = new Set()
      const seenHierarchies = new Set()

      rows.forEach(r => {
        const ps = this.parseTagsToPairs(r.tags)
        ps.forEach(({ parent, child, hierarchy, levels }) => {
          if (!parent) return

          // 如果是多层级（3层或以上），使用新的hierarchies API
          if (levels && levels.length >= 3) {
            if (!seenHierarchies.has(hierarchy)) {
              seenHierarchies.add(hierarchy)
              hierarchies.push(hierarchy)
            }
          } else {
            // 两层结构使用旧的pairs API
            const key = parent + '|||' + (child || '')
            if (!seen.has(key)) {
              seen.add(key)
              pairs.push({ parent, child })
            }
          }
        })
      })

      if (pairs.length === 0 && hierarchies.length === 0) return

      const loader = this.$loading({
        lock: true,
        text: '知识点校验中...'
      })
      try {
        // 优先使用新的hierarchies API（支持多层级）
        if (hierarchies.length > 0) {
          await batchEnsureHierarchicalKnowledge(hierarchies, undefined, this.query.repoId, this.getCourseTypeForKnowledge())
        }
        // 如果还有两层结构的，也要处理
        if (pairs.length > 0) {
          await batchEnsureGeneralKnowledge(pairs, undefined, this.query.repoId, this.getCourseTypeForKnowledge())
        }
      } finally {
        loader.close()
      }
    },
    async ensureNodeId(content, parentId = 0) {
      if (!content) return 0
      try {
        const resp = await getGeneralKnowledgeByContent(content, parentId, this.query.repoId, this.getCourseTypeForKnowledge())
        const data = (resp && resp.data) || resp || null
        if (Array.isArray(data)) {
          const it = data[0]
          return (it && (it.id || it.ID)) || 0
        }
        return (data && (data.id || data.ID)) || 0
      } catch (_) {
        return 0
      }
    },
    async ensureOrCreateNodeId(content, parentId = 0) {
      let id = await this.ensureNodeId(content, parentId)
      if (!id) {
        const cr = await createGeneralKnowledge({ content, parentId, repoId: this.query.repoId, courseType: this.getCourseTypeForKnowledge() })
        const cdata = (cr && cr.data) || cr || {}
        id = cdata.id || cdata.ID || 0
      }
      return id
    },
    async resolveKnowledgeIdFromTags(tags) {
      const pairs = this.parseTagsToPairs(tags)
      if (!pairs || pairs.length === 0) return 0
      const { parent, child } = pairs[0]
      if (!parent) return 0
      const parentId = await this.ensureOrCreateNodeId(parent, 0)
      if (!child) return parentId
      const childId = await this.ensureOrCreateNodeId(child, parentId)
      return childId || parentId
    },
    async fetchList() {
      if (!this.query.repoId) return
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        content: this.query.content || null,
        year: this.query.year || null
      }
      try {
        const res = await pagingByRepoId(this.query.repoId, params)
        if (res && res.code) {
          this.list = res.data || { records: [], total: 0, size: this.pageSize, current: this.pageNum }
          // 兼容处理：如果 records 有数据但 total 为 0，修正 total 以便分页组件正常显示
          if (this.list.total === 0 && this.list.records && this.list.records.length > 0) {
            this.list.total = this.list.records.length
          }
          // 按需为当前页的知识点ID拉取名称，避免首屏全量请求
          this.refreshKnowledgeNamesFromList()
        } else {
          this.list = { records: [], total: 0, size: this.pageSize, current: this.pageNum }
        }
      } finally {
        this.loading = false
      }
    },
    // 为当前列表中的知识点ID按需加载名称
    // loadKnowledgeOptions 已通过 /tree 接口填充了全部节点，无需再逐个请求
    async refreshKnowledgeNamesFromList() {
    },
    search() {
      this.pageNum = 1
      this.fetchList()
      this.clearSelection()
    },
    resetSearch() {
      this.query.content = ''
      this.query.year = ''
      this.search()
      this.clearSelection()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchList()
      this.clearSelection()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.fetchList()
      this.clearSelection()
    },
    // 构建 id->name 映射（用于展示）
    buildIdNameMapFromCache() {
      const out = {}
      if (!this._knowledgeIdCache || this._knowledgeIdCache.size === 0) return out
      this._knowledgeIdCache.forEach((id, key) => {
        if (typeof id !== 'number') return
        const parts = key.split('||')
        if (parts.length >= 1) {
          const parent = parts[0]
          const child = parts[1] || ''
          const name = child || parent
          out[id] = name
        }
      })
      return out
    },
    // 将 knowledge 的 ID 列表映射为名称
    getKnowledgeDisplay(knowledgeField) {
      if (!knowledgeField) return '—'
      const parts = String(knowledgeField)
        .split(/[,，]/)
        .map(s => String(s).trim())
        .filter(Boolean)

      if (parts.length === 0) return '—'

      // 1) 优先：提取包含非数字字符的片段（一般就是中文名称，如 "算术-平均数"）
      const nameParts = parts.filter(p => /[^0-9]/.test(p))
      if (nameParts.length > 0) {
        return nameParts.join(', ')
      }

      // 2) 退路：全是数字时，再做 ID→名称 映射
      const ids = parts
        .map(p => Number(p))
        .filter(n => !isNaN(n) && n > 0)
      if (ids.length === 0) return knowledgeField
      // _knowledgeIdNameMap 在组件生命周期早期可能尚未初始化，这里增加一次兜底保护
      const map = this._knowledgeIdNameMap || {}
      const names = ids.map(id => map[id] || map[String(id)] || id)
      return names.join(', ')
    },
    selectedKnowledgeDisplay(selectedIds) {
      if (!selectedIds) return '—'
      const ids = Array.isArray(selectedIds)
        ? selectedIds
        : String(selectedIds)
          .split(/[,，]/)
          .map(s => s.trim())
          .filter(Boolean)
      if (!ids.length) return '—'
      const map = this.knowledgePathMap || {}
      const names = ids.map(id => map[id] || map[String(id)] || this._knowledgeIdNameMap[id] || this._knowledgeIdNameMap[String(id)] || id)
      return names.join('；')
    },
    // 可编辑结果辅助
    resetEditedResults() {
      // 确保年份下拉有数据
      if (!this.yearOptions || this.yearOptions.length === 0) {
        this.generateYearOptions()
      }
      if (!this.fullYearOptions || this.fullYearOptions.length === 0) {
        this.generateFullYearOptions()
      }
      // 深拷贝归一化结果，作为可编辑副本；难度优先用 question_id 的后两位
      this.editResults = this.normalizedResults.map((it, idx) => {
        const qid = it.question_id || (idx + 1)
        const parsed = this.parseQuestionId(String(qid))
        let difficultyStr = ''
        if (parsed.difficultyCode) {
          const label = this.getDifficultyLabel(parsed.difficultyCode)
          difficultyStr = `${parsed.difficultyCode}(${label})`
        } else if (it.difficulty) {
          // 尝试从原字段转换为 NN(标签)
          const numMatch = String(it.difficulty).match(/\d+/)
          if (numMatch) {
            const code = String(parseInt(numMatch[0], 10)).padStart(2, '0')
            const label = this.getDifficultyLabel(code)
            difficultyStr = `${code}(${label})`
          }
        }
        return {
          question_id: qid,
          index: String(it.index || it.question_id || (idx + 1)),
          year: it.year || '',
          stem: it.stem || it.content || '',
          options: Array.isArray(it.options) ? it.options.map(opt => typeof opt === 'object' ? { text: opt.text || '', image: opt.image || '' } : { text: opt || '', image: '' }) : [],
          // 携带中文选项（如有），用于保存阶段写入 optionsCn
          cnOptions: Array.isArray(it.cnOptions) ? it.cnOptions.slice() : null,
          contentEn: it.contentEn || '',
          contentCn: it.contentCn || '',
          analysisEn: it.analysisEn || '',
          analysisCn: it.analysisCn || '',
          correctAnswer: it.correctAnswer || '',
          tags: it.tags || '',
          difficulty: difficultyStr || ''
        }
      })
    },

    addQuestion() {
      const nextId = (this.editResults.reduce((m, x) => Math.max(m, Number(x.question_id) || 0), 0) || 0) + 1
      this.editResults.push({ question_id: nextId, index: '', year: '', stem: '', options: [] })
    },
    removeQuestion(index) {
      this.editResults.splice(index, 1)
    },
    addOption(qIndex) {
      if (!this.editResults[qIndex].options) this.editResults[qIndex].options = []
      this.editResults[qIndex].options.push({ text: '', image: '' })
    },
    removeOption(qIndex, optIndex) {
      if (!this.editResults[qIndex].options) return
      this.editResults[qIndex].options.splice(optIndex, 1)
    },
    clearImportOptionImage(qIndex, optIndex) {
      if (!this.editResults[qIndex] || !Array.isArray(this.editResults[qIndex].options)) return
      const opt = this.editResults[qIndex].options[optIndex]
      if (!opt) return
      this.$set(this.editResults[qIndex].options[optIndex], 'image', '')
      this.$message.success('已删除选项图片，可重新上传')
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || []
    },
    clearSelection() {
      this.selectedRows = []
      this.$nextTick(() => {
        if (this.$refs && this.$refs.questionTable && this.$refs.questionTable.clearSelection) {
          this.$refs.questionTable.clearSelection()
        }
      })
    },
    async handleBatchDelete() {
      const ids = (this.selectedRows || []).map(r => r.id).filter(Boolean)
      if (!ids.length) return
      try {
        await this.$confirm(`确认删除选中的 ${ids.length} 道题吗？`, '提示', { type: 'warning', confirmButtonText: '确定', cancelButtonText: '取消' })
      } catch (_) {
        return
      }
      const loader = this.$loading({ lock: true, text: '删除中...' })
      try {
        const res = await batchDeleteQuestions(ids.join(','))
        if (res && (res.code === 1 || res.code === true)) {
          this.$message.success(res.msg || '删除成功')
          this.fetchList()
          this.clearSelection()
        } else {
          this.$message.error((res && res.msg) || '删除失败')
        }
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      } finally {
        loader.close()
      }
    },
    // 将文本中的 LaTeX 公式渲染为 HTML（支持 \(...\) 行内 与 \[...\] 块级）
    renderMathFormula(text) {
      if (!text) return ''
      const safe = String(text).replace(/\n/g, '<br>')
      try {
        // 1) 行内公式: \(...\)
        let html = safe.replace(/\\\(([^)]+)\\\)/g, (match, formula) => {
          try {
            return katex.renderToString(formula, { throwOnError: false, displayMode: false })
          } catch (e) {
            return match
          }
        })
        // 2) 块级公式: \[...\]
        html = html.replace(/\\\[([^\]]+)\\\]/g, (match, formula) => {
          try {
            return katex.renderToString(formula, { throwOnError: false, displayMode: true })
          } catch (e) {
            return match
          }
        })
        // 3) 块级公式: $$...$$
        html = html.replace(/\$\$([\s\S]+?)\$\$/g, (match, formula) => {
          try {
            return katex.renderToString(formula, { throwOnError: false, displayMode: true })
          } catch (e) {
            return match
          }
        })
        // 4) 行内公式: $...$ （避免与 $$...$$ 冲突，使用(?!\$)规则）
        html = html.replace(/\$(?!\$)([^$]+?)\$(?!\$)/g, (match, formula) => {
          try {
            return katex.renderToString(formula, { throwOnError: false, displayMode: false })
          } catch (e) {
            return match
          }
        })
        return html
      } catch (e) {
        return safe
      }
    },
    // 去掉内嵌图片后再渲染公式，避免与独立图片列重复显示
    renderContentWithoutImage(text) {
      if (!text) return ''
      // 粗略移除所有 <img ...> 标签
      const noImg = String(text).replace(/<img[^>]*>/gi, '')
      return this.renderMathFormula(noImg)
    },
    // 结果统计与展示辅助
    getChoiceCount() {
      return this.normalizedResults.filter(q => q.options && q.options.length > 0).length
    },
    getEssayCount() {
      return this.normalizedResults.filter(q => !q.options || q.options.length === 0).length
    },
    // 从显示值中提取用于入库的难度编码：例如 '01(简单)' -> '1'，'25(困难)' -> '25'
    extractDifficultyCode(input) {
      if (input === null || input === undefined) return ''
      if (typeof input === 'number') {
        if (isNaN(input)) return ''
        const n = parseInt(input, 10)
        return isNaN(n) ? '' : String(n)
      }
      const s = String(input).trim()
      if (!s) return ''
      const m = s.match(/(\d{1,2})/)
      if (!m) return ''
      const n = parseInt(m[1], 10)
      if (isNaN(n)) return ''
      return String(n)
    },
    stripOptionPrefix(opt, idx) {
      if (!opt) return ''
      const idxLetter = String.fromCharCode(65 + idx)
      return String(opt)
        .replace(new RegExp(`^\\(${idxLetter}\\)\\s*`), '')
        .replace(/^[A-E][\.|\)]\s*/, '')
        .trim()
    },
    addManualOption() {
      this.postForm.options.push({ text: '', textEn: '', image: '' })
    },
    removeManualOption(index) {
      this.postForm.options.splice(index, 1)
    },
    async loadKnowledgeOptions() {
      try {
        const resp = await listGeneralKnowledgeTree(this.query.repoId)
        const roots = resp?.data || []

        this._knowledgeIdNameMap = {}

        const flat = []
        const walk = (nodes, prefix) => {
          if (!Array.isArray(nodes)) return
          nodes.forEach(node => {
            if (!node || node.id == null) return
            const label = (prefix ? (prefix + '-') : '') + String(node.content || '')
            flat.push({ value: node.id, label })
            if (node.children && node.children.length) {
              walk(node.children, label)
            }
          })
        }
        walk(roots, '')

        // 递归展平所有节点，填充 id->name 映射
        const fillMap = (nodes) => {
          if (!Array.isArray(nodes)) return
          nodes.forEach(node => {
            if (node && node.id != null && node.content != null) {
              this.$set(this._knowledgeIdNameMap, String(node.id), String(node.content))
            }
            if (node.children && node.children.length) fillMap(node.children)
          })
        }
        fillMap(roots)

        // 构建 id -> 完整路径 映射，用于已选知识点摘要显示
        const pathMap = {}
        const fillPathMap = (nodes, parentPath) => {
          if (!Array.isArray(nodes)) return
          nodes.forEach(node => {
            if (!node || node.id == null) return
            const currentPath = parentPath ? `${parentPath} / ${String(node.content || '')}` : String(node.content || '')
            pathMap[node.id] = currentPath
            if (node.children && node.children.length) fillPathMap(node.children, currentPath)
          })
        }
        fillPathMap(roots, '')

        this.knowledgeOptions = roots
        this.flatKnowledgeOptions = flat
        this.knowledgePathMap = pathMap
      } catch (e) {
        console.error('加载知识点失败:', e)
      }
    },
    async submitForm() {
      this.$refs.postForm.validate(async (valid) => {
        if (!valid) return

        const payload = JSON.parse(JSON.stringify(this.postForm))
        const userInfo = getTokenInfo()
        if (userInfo && userInfo.realName) {
          payload.realName = userInfo.realName
        }

        // 处理选项：转换为分号分隔的字符串格式
        if (payload.options && payload.options.length > 0) {
          const optionsCn = []
          const optionsEn = []
          const optionImages = []
          let hasEnText = false

          payload.options.forEach((opt, idx) => {
            const letter = String.fromCharCode(65 + idx)
            let cnText = opt.text || ''
            let enText = opt.textEn || ''

            if (enText) hasEnText = true

            // 如果有图片，添加图片标记
            if (opt.image) {
              cnText = cnText ? `${cnText} ![](${opt.image})` : `![](${opt.image})`
              enText = enText ? `${enText} ![](${opt.image})` : `![](${opt.image})`
              optionImages.push(opt.image)
            }

            if (cnText) optionsCn.push(`(${letter}) ${cnText}`)
            if (enText) optionsEn.push(`(${letter}) ${enText}`)
          })

          // 只有当有实际内容时才设置字段
          if (optionsCn.length > 0) {
            payload.optionsCn = optionsCn.join(';')
          }
          if (optionsEn.length > 0 && hasEnText) {
            payload.optionsEn = optionsEn.join(';')
          }
          if (optionImages.length > 0) {
            payload.optionImages = optionImages.join(';')
          }
        }

        // 删除原始 options 数组，使用字符串格式
        delete payload.options

        // 清理空字段：只保留有值的字段
        Object.keys(payload).forEach(key => {
          if (payload[key] === '' || payload[key] === null || payload[key] === undefined) {
            delete payload[key]
          }
        })

        // 处理知识点：将ID数组转换为逗号分隔的字符串
        if (payload.knowledgeIds && payload.knowledgeIds.length > 0) {
          payload.knowledge = payload.knowledgeIds.join(', ')
          payload.knowledgeId = payload.knowledgeIds[0]
        }
        delete payload.knowledgeIds

        // 兼容：同时附带 legacy 字段，避免旧接口报错（只在有值时添加）
        if (payload.contentCn || payload.contentEn) {
          payload.content = payload.contentCn || payload.contentEn
        }
        if (payload.analysisCn || payload.analysisEn) {
          payload.analysis = payload.analysisCn || payload.analysisEn
        }

        try {
          const res = await addQuestion(payload)
          if (res && res.code) {
            this.$notify({ title: '成功', message: '试题保存成功！', type: 'success', duration: 2000 })
            this.showManualForm = false
            // 重置表单
            this.postForm = {
              repoId: String(this.$route.query.repoId || ''),
              number: '',
              title: '',
              contentCn: '',
              contentEn: '',
              options: [],
              answer: '',
              analysisCn: '',
              analysisEn: '',
              knowledgeIds: [],
              difficulty: '',
              year: '',
              source: '',
              tags: '',
              url: '',
              image: ''
            }
            this.fetchList()
          } else {
            this.$notify({ title: '失败', message: (res && res.msg) || '保存失败', type: 'error', duration: 2000 })
          }
        } catch (e) {
          this.$notify({ title: '异常', message: e.message || '请求失败', type: 'error', duration: 2000 })
        }
      })
    },
    async saveImportResults() {
      const repoId = this.query.repoId || this.postForm.repoId
      if (!repoId) {
        this.$message.warning('请先选择题库后再保存')
        return
      }
      if (!this.editResults || this.editResults.length === 0) {
        this.$message.warning('没有可保存的题目')
        return
      }
      const userInfo = getTokenInfo()
      const isWord = this.importType === 'word'

      const payload = this.editResults.map((q, idx) => {
        const hasOptions = Array.isArray(q.options) && q.options.length > 0
        // 提取选项文本和图片（兼容对象格式和字符串格式）
        const optionTexts = hasOptions ? q.options.map(opt => typeof opt === 'object' ? (opt.text || '') : opt) : []
        const optionImages = hasOptions ? q.options.map(opt => typeof opt === 'object' ? (opt.image || '') : '') : []
        const optStr = optionTexts.join(';')
        const optImgStr = optionImages.filter(img => img).join(';')

        if (isWord) {
          // 知识点ID处理：优先使用预处理好的 knowledge 字段（逗号分隔的ID字符串）
          // 如果为空，尝试从 tags 再次解析
          let knowledgeStr = q.knowledge || ''
          let firstId

          if (knowledgeStr) {
             const parts = knowledgeStr.split(',').map(s => s.trim()).filter(Boolean)
             if (parts.length > 0) firstId = parts[0]
          } else if (q.tags) {
             // 兜底：如果 knowledge 为空但有 tags，尝试解析
             const ids = this.getKnowledgeIdsFromCache(q.tags)
             if (ids && ids.length > 0) {
               knowledgeStr = ids.join(', ')
               firstId = ids[0]
             }
          }

          // 选项字符串：英文/通用来自 q.options；中文优先用 q.cnOptions
          const cnOptStr = (Array.isArray(q.cnOptions) && q.cnOptions.length) ? q.cnOptions.join(';') : optStr
          return {
            // 兼容旧字段
            content: (q.contentCn || q.contentEn || q.stem || ''),
            // 新双语字段
            contentCn: q.contentCn || '',
            contentEn: q.contentEn || '',
            // 选项与类型
            options: optStr,
            // 同步写入中英文选项字段（后端两个字段实际一致）
            optionsCn: cnOptStr,
            optionsEn: optStr,
            options_cn: cnOptStr,
            options_en: optStr,
            // 选项图片
            optionImages: optImgStr,
            option_images: optImgStr,
            quType: hasOptions ? 1 : 4,
            // 解析与答案
            analysis: (q.analysisCn || q.analysisEn || ''),
            analysisCn: q.analysisCn || '',
            analysisEn: q.analysisEn || '',
            answer: q.correctAnswer || '',
            // 图片
            image: q.image || '',
            // 题干图片（JSON 字符串数组）
            imagePaths: q.imagePaths || (q.image ? JSON.stringify([q.image]) : null),
            // 其他映射到数据库字段
            knowledge: knowledgeStr,
            knowledgeId: firstId,
            repoId: repoId,
            level: 1,
            evaluate: '',
            difficulty: this.extractDifficultyCode(q.difficulty),
            realName: userInfo && userInfo.realName ? userInfo.realName : undefined,
            // 新增字段：后端数据库 number 列
            number: q.index || q.question_id || '',
            year: q.year || ''
          }
        }
        // OCR/PDF 分支：对齐数据库字段
        return {
          // 兼容：content 仍填充（便于旧接口）
          content: q.stem || '',
          // 双语占位均用 stem
          contentCn: q.stem || '',
          contentEn: q.stem || '',
          // 选项与题型
          options: optStr,
          // 同步写入中英文选项字段（后端两个字段实际一致）
          optionsCn: optStr,
          optionsEn: optStr,
          options_cn: optStr,
          options_en: optStr,
          // 选项图片
          optionImages: optImgStr,
          option_images: optImgStr,
          quType: hasOptions ? 1 : 4,
          // 解析与答案（OCR/PDF 无，置空）
          analysis: '',
          analysisCn: '',
          analysisEn: '',
          answer: '',
          // 题干图片（JSON 字符串数组）
          imagePaths: q.imagePaths || (q.image ? JSON.stringify([q.image]) : null),
          // 标签对应 knowledge（暂无，置空）
          knowledge: '',
          // 其他
          repoId: repoId,
          level: 1,
          evaluate: '',
          difficulty: this.extractDifficultyCode(q.difficulty),
          realName: userInfo && userInfo.realName ? userInfo.realName : undefined
        }
      })
      try {
        const res = await saveQuestions(payload)
        if (res && res.code === 1) {
          this.$message.success(res.msg || '保存成功')
          this.importResultVisible = false
          this.ocrFileList = []
          this.pdfFileList = []
          this.wordFileList = []
          this.ocrResults = []
          this.pdfResults = []
          this.wordResults = []
          this.editResults = []
          this.fetchList()
        } else {
          const msg = (res && res.msg) || ''
          if (String(msg).includes('已存在') || String(msg).includes('主键冲突')) {
            this.$message.warning(msg || '部分题目已存在，已跳过')
            // 仍然尝试刷新列表，避免用户误以为未生效
            this.fetchList()
          } else {
            this.$message.error(msg || '保存失败')
          }
        }
      } catch (e) {
        this.$message.error('保存失败：' + (e.message || '未知错误'))
      }
    },
    // 编辑相关
    openEdit(row) {
      // 深拷贝一份，避免直接改表格数据
      const knowledgeStr = row.knowledge || ''
      const knowledgeIds = knowledgeStr ? knowledgeStr.split(/[,，]/).map(s => {
        const trimmed = String(s).trim()
        // 支持纯数字ID
        if (/^\d+$/.test(trimmed)) {
          return Number(trimmed)
        }
        // 也尝试从缓存或名称映射中查找 ID
        // 简单起见，这里假设后端返回的 knowledge 已经是 ID 字符串
        // 如果是名称，可能无法正确回显，需要 loadKnowledgeOptions 中的映射表
        // 实际上 getKnowledgeDisplay 用了 _knowledgeIdNameMap，说明 row.knowledge 存的是 ID
        return null
      }).filter(id => id !== null) : []

      this.editForm = {
        id: row.id,
        number: row.number || '',
        imagePaths: row.imagePaths || row.image_paths || '',
        contentCn: row.contentCn || '',
        contentEn: row.contentEn || row.content || '',
        answer: row.answer || '',
        analysisCn: row.analysisCn || '',
        analysisEn: row.analysisEn || row.analysis || '',
        repoId: row.repoId,
        courseId: row.courseId || null,
        uploader: row.uploader || '',
        knowledge: knowledgeStr,
        knowledgeIds: knowledgeIds,
        optionsCn: row.optionsCn || row.options_cn || row.options || '',
        optionsEn: row.optionsEn || row.options_en || row.options || '',
        // 确保 optionImages 字段从 row 中正确读取（支持驼峰或下划线）
        optionImages: row.optionImages || row.option_images || '',
        difficulty: row.difficulty || '',
        year: row.year || '',
        source: row.source || '',
        url: row.url || ''
      }
      this.resetEditImageUploader()
      this.editDialogVisible = true
    },
    handleEditKnowledgeChange(selectedIds) {
      // 将选中的知识点 ID 数组转换为逗号分隔的字符串
      if (selectedIds && selectedIds.length > 0) {
        this.editForm.knowledge = selectedIds.join(', ')
      } else {
        this.editForm.knowledge = ''
      }
    },
    showAddKnowledgeDialog() {
      this.newKnowledgeName = ''
      this.newKnowledgeParentId = 0
      this.addKnowledgeDialogVisible = true
    },
    async confirmAddKnowledge() {
      if (!this.newKnowledgeName || !this.newKnowledgeName.trim()) {
        this.$message.warning('请输入知识点名称')
        return
      }
      try {
        const payload = {
          content: this.newKnowledgeName.trim(),
          parentId: this.newKnowledgeParentId || 0,
          repoId: this.query.repoId,
          courseType: this.getCourseTypeForKnowledge()
        }
        const res = await createGeneralKnowledge(payload)
        if (res && (res.code === 1 || res.code === 200)) {
          this.$message.success('知识点创建成功')
          this.addKnowledgeDialogVisible = false
          await this.loadKnowledgeOptions()
          // 自动选中新创建的知识点
          const newId = res.data?.id || res.data?.ID
          if (newId && this.editForm.knowledgeIds) {
            this.editForm.knowledgeIds.push(newId)
            this.handleEditKnowledgeChange(this.editForm.knowledgeIds)
          }
        } else {
          this.$message.error('创建失败：' + (res?.msg || res?.message || '未知错误'))
        }
      } catch (e) {
        console.error('创建知识点失败:', e)
        this.$message.error('创建失败：' + (e.message || '未知错误'))
      }
    },
    async previewPaper() {
      if (!this.query.repoId) {
        this.$message.warning('请先选择题库')
        return
      }
      if (!this.query.year) {
        this.$message.warning('请先选择年份后再预览')
        return
      }
      this.previewQuestions = []
      this.previewDialogVisible = true
      this.previewLoading = true
      try {
        const res = await pagingByRepoId(this.query.repoId, {
          pageNum: 1,
          pageSize: 1000,
          year: this.query.year
        })
        const records = res?.data?.records || res?.data || []
        this.previewQuestions = Array.isArray(records) ? records : []
      } catch (e) {
        this.$message.error('加载题目失败：' + (e.message || '未知错误'))
      } finally {
        this.previewLoading = false
      }
    },
    printPaper() {
      const el = document.getElementById('paper-print-area')
      if (!el) return
      const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>试卷预览</title><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css"><style>*{box-sizing:border-box;}body{margin:0;padding:20px;font-family:'Source Han Serif CN','Songti SC','SimSun',serif;font-size:14px;color:#111;background:#fff;}.a4-paper{width:794px;margin:0 auto;padding:60px 72px;}.paper-header{text-align:center;margin-bottom:12px;}.paper-title{font-size:22px;font-weight:700;}.paper-meta{font-size:13px;color:#666;margin-top:6px;}.paper-divider{border-top:2px solid #111;margin:16px 0 24px;}.paper-question{margin-bottom:24px;page-break-inside:avoid;}.pq-stem{display:flex;gap:6px;line-height:1.8;font-size:14px;}.pq-no{font-weight:700;min-width:24px;}.pq-img-wrap{margin:10px 0 10px 28px;}.pq-img{max-width:420px;max-height:300px;object-fit:contain;}.pq-options{margin-top:8px;margin-left:28px;display:grid;grid-template-columns:repeat(2,1fr);gap:4px 24px;}.pq-option{font-size:13px;line-height:1.7;}</style></head><body>${el.innerHTML}</body></html>`
      const w = window.open('', '_blank')
      if (!w) { this.$message.error('浏览器阻止了弹窗，请允许弹窗后重试'); return }
      w.document.write(html)
      w.document.close()
      w.focus()
      setTimeout(() => { w.print() }, 600)
    },
    async submitEdit() {
      if (!this.editForm || !this.editForm.id) return
      try {
        const payload = { ...this.editForm }

        // 处理新上传的图片：追加到 imagePaths
        if (this.editFormNewImage) {
          let currentImages = []
          if (payload.imagePaths) {
            try {
              currentImages = JSON.parse(payload.imagePaths)
              if (!Array.isArray(currentImages)) currentImages = []
            } catch (e) {
              currentImages = []
            }
          }
          currentImages.push(this.editFormNewImage)
          payload.imagePaths = JSON.stringify(currentImages)
        }

        // 同步写入中英文选项字段
        const cnStr = payload.optionsCn || ''
        const enStr = payload.optionsEn || cnStr
        payload.optionsCn = cnStr
        payload.optionsEn = enStr

        // 处理知识点：优先使用 knowledgeIds，如果没有则使用 knowledge 字段
        if (payload.knowledgeIds && payload.knowledgeIds.length > 0) {
          payload.knowledge = payload.knowledgeIds.join(', ')
          payload.knowledgeId = payload.knowledgeIds[0]
        } else if (payload && payload.knowledge) {
          const tokens = String(payload.knowledge)
            .split(/[,，]/)
            .map(s => String(s).trim())
            .filter(Boolean)
          const allNumeric = tokens.length > 0 && tokens.every(t => /^\d+$/.test(t))
          if (allNumeric) {
            const ids = tokens.map(t => Number(t)).filter(n => !isNaN(n) && n > 0)
            if (ids.length) {
              payload.knowledge = ids.join(', ')
              payload.knowledgeId = ids[0]
            }
          } else {
            const ids = []
            for (const tk of tokens) {
              const parts = tk.split('-').map(s => s.trim()).filter(Boolean)
              if (parts.length >= 2) {
                const pid = await this.ensureNodeId(parts[0], 0)
                if (pid) {
                  const cid = await this.ensureNodeId(parts[1], pid)
                  if (cid) {
                    ids.push(cid)
                  } else {
                    ids.push(pid)
                  }
                }
              } else {
                const id = await this.ensureNodeId(parts[0], 0)
                if (id) ids.push(id)
              }
            }
            if (ids.length) {
              payload.knowledge = ids.join(', ')
              payload.knowledgeId = ids[0]
            }
          }
        }
        // 后端如无需某些字段，可在此剔除
        payload.id = this.editForm.id
        const res = await updateQuestion(payload)
        if (res && res.code) {
          this.$notify({ title: '成功', message: '更新成功', type: 'success', duration: 2000 })
          this.resetEditImageUploader()
          this.editDialogVisible = false
          this.fetchList()
        } else {
          this.$notify({ title: '失败', message: (res && res.msg) || '更新失败', type: 'error', duration: 2000 })
        }
      } catch (e) {
        this.$notify({ title: '异常', message: e.message || '请求失败', type: 'error', duration: 2000 })
      }
    }
  }
}
</script>

<style scoped>
/* ========== 试卷预览 A4 样式 ========== */
.a4-paper {
  width: 794px;
  min-height: 1123px;
  margin: 0 auto;
  background: #fff;
  padding: 60px 72px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  border-radius: 2px;
  font-family: 'Source Han Serif CN', 'Songti SC', 'SimSun', serif;
  font-size: 14px;
  color: #111;
  line-height: 1.8;
}
.paper-header {
  text-align: center;
  margin-bottom: 12px;
}
.paper-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 2px;
}
.paper-meta {
  font-size: 13px;
  color: #666;
  margin-top: 6px;
}
.paper-divider {
  border-top: 2px solid #111;
  margin: 16px 0 24px;
}
.paper-question {
  margin-bottom: 26px;
  page-break-inside: avoid;
}
.pq-stem {
  display: flex;
  gap: 6px;
  line-height: 1.8;
  font-size: 14px;
  align-items: flex-start;
}
.pq-no {
  font-weight: 700;
  min-width: 26px;
  flex-shrink: 0;
}
.pq-img-wrap {
  margin: 10px 0 10px 30px;
}
.pq-img {
  max-width: 460px;
  max-height: 320px;
  object-fit: contain;
  border: 1px solid #eee;
}
.pq-options {
  margin-top: 10px;
  margin-left: 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px 32px;
}
.pq-option {
  font-size: 13.5px;
  line-height: 1.7;
}

.knowledge-cascader /deep/ .el-cascader__tags {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: calc(100% - 36px);
  white-space: nowrap;
}

.knowledge-cascader /deep/ .el-cascader__tags .el-tag {
  flex: 0 0 auto;
}

.knowledge-cascader /deep/ .el-cascader__tags .el-tag + .el-tag {
  margin-left: 6px;
}

.knowledge-summary {
  margin-top: 8px;
  color: #606266;
  font-size: 12px;
  line-height: 1.6;
  word-break: break-word;
}

/* 全屏弹窗内容区撑满高度 */
.paper-preview-dialog .el-dialog__body {
  padding: 0;
  height: calc(100vh - 54px);
  overflow-y: auto;
}
</style>
